//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,of, observable
} from "rxjs";
//import 'rxjs/add/observable/of';
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable({
  providedIn: "root",
})
export class AlertClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Send a SMS alert to support.
   * @param alert The message to be sent.
   * @return Successfully sent a SMS alert
   */
  sendSMSAlert(alert: AlertRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Alert/SMS";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(alert);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendSMSAlert(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendSMSAlert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendSMSAlert(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Send an email alert to support.
   * @param alert The message to be sent.
   * @return Successfully sent an email alert
   */
  sendEmailAlert(alert: AlertRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Alert/Email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(alert);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendEmailAlert(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendEmailAlert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendEmailAlert(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class AttachmentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get all attachments for a given booking.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  getBookingAttachments(id: number): Observable<AttachmentResponse[]> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Attachment";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingAttachments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingAttachments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                AttachmentResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              AttachmentResponse[]
            >;
        })
      );
  }

  protected processGetBookingAttachments(
    response: HttpResponseBase
  ): Observable<AttachmentResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(AttachmentResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<AttachmentResponse[]>(<any>null);
    
  }

  /**
   * Add an attachment to the given booking.
   * @param id The booking's identifier.
   * @param att The new attachment to be stored.
   * @return Successfully added a new attachment to the booking
   */
  createBookingAttachment(
    id: number,
    att: string
  ): Observable<AttachmentResponse> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Attachment";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(att);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBookingAttachment(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBookingAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AttachmentResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AttachmentResponse>;
        })
      );
  }

  protected processCreateBookingAttachment(
    response: HttpResponseBase
  ): Observable<AttachmentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AttachmentResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AttachmentResponse>(null as any);
  }

  /**
   * Get an attachment.
   * @param id The attachment's identifier.
   * @return Successful operation
   */
  getBookingAttachmentImage(id: number): Observable<AttachmentImageResponse> {
    let url_ = this.baseUrl + "/api/Booking/Attachment/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingAttachmentImage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingAttachmentImage(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AttachmentImageResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AttachmentImageResponse>;
        })
      );
  }

  protected processGetBookingAttachmentImage(
    response: HttpResponseBase
  ): Observable<AttachmentImageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AttachmentImageResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified attachment was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AttachmentImageResponse>(null as any);
  }

  /**
   * Update an attachment.
   * @param id The attachment's identifier.
   * @param att The new attachment to be stored.
   * @return Successful operation
   */
  updateAttachment(id: number, att: string): Observable<AttachmentResponse> {
    let url_ = this.baseUrl + "/api/Booking/Attachment/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(att);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAttachment(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAttachment(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AttachmentResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AttachmentResponse>;
        })
      );
  }

  protected processUpdateAttachment(
    response: HttpResponseBase
  ): Observable<AttachmentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AttachmentResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified attachment was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AttachmentResponse>(null as any);
  }

  /**
   * Add an attachment to the given booking, anonymously using a Single Use Key.
   * @param id The booking's identifier.
   * @param att The new attachment to be stored, and a Single Use Key.
   * @return Successfully added a new attachment to the booking
   */
  createBookingAttachmentAnonymous(
    id: number,
    att: AttachmentRequestAnonymous
  ): Observable<AttachmentResponse> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Attachment/Anonymous";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(att);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBookingAttachmentAnonymous(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBookingAttachmentAnonymous(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AttachmentResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AttachmentResponse>;
        })
      );
  }

  protected processCreateBookingAttachmentAnonymous(
    response: HttpResponseBase
  ): Observable<AttachmentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AttachmentResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AttachmentResponse>(null as any);
  }

  /**
   * Cache an attachment to the user's current session.
   * @param att The attachment to store.
   * @return Successfully cached an attachment
   */
  createUserCache(att: string): Observable<CacheResponse> {
    let url_ = this.baseUrl + "/api/Booking/Attachment/Cache";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(att);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserCache(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUserCache(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CacheResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CacheResponse>;
        })
      );
  }

  protected processCreateUserCache(
    response: HttpResponseBase
  ): Observable<CacheResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CacheResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CacheResponse>(null as any);
  }

  /**
   * Delete all cached attachments from the user's current session.
   * @return Successfully deleted all cached attachments
   */
  deleteAllUserCache(): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/Attachment/Cache";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAllUserCache(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAllUserCache(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteAllUserCache(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Delete a cached attachment from the user's current session.
   * @param id The attachment's identifier.
   * @return Successfully deleted all cached attachments
   */
  deleteUserCache(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/Attachment/Cache/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserCache(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUserCache(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteUserCache(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified attachment was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class BookingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get bookings for a given location.
   * @param locationId (optional) The location's identifier (use 0 for all).
   * @param forAllStatus (optional) All booking statuses.
   * @param isActive (optional) Active bookings only.
   * @param isUrgent (optional) Urgent bookings only.
   * @param isNotes (optional) Has unread inbound notes.
   * @param fromAge (optional) The minimum age of bookings (optional, in 'd.h:m:s.ms' format).
   * @param toAge (optional) The maximum age of bookings (optional, in 'd.h:m:s.ms' format).
   * @return Successful operation
   */
  getBookings(
    locationId: number | undefined,
    forAllStatus: string | undefined,
    isActive: boolean | undefined,
    isUrgent: boolean | undefined,
    isNotes: boolean | undefined,
    fromAge: string | null | undefined,
    toAge: string | null | undefined
  ): Observable<BookingResponse[]> {
    let url_ = this.baseUrl + "/api/Booking?";
    if (locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined)
      url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    if (forAllStatus === null)
      throw new Error("The parameter 'forAllStatus' cannot be null.");
    else if (forAllStatus !== undefined)
      url_ += "forAllStatus=" + encodeURIComponent("" + forAllStatus) + "&";
    if (isActive === null)
      throw new Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined)
      url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
    if (isUrgent === null)
      throw new Error("The parameter 'isUrgent' cannot be null.");
    else if (isUrgent !== undefined)
      url_ += "isUrgent=" + encodeURIComponent("" + isUrgent) + "&";
    if (isNotes === null)
      throw new Error("The parameter 'isNotes' cannot be null.");
    else if (isNotes !== undefined)
      url_ += "isNotes=" + encodeURIComponent("" + isNotes) + "&";
    if (fromAge !== undefined && fromAge !== null)
      url_ += "fromAge=" + encodeURIComponent("" + fromAge) + "&";
    if (toAge !== undefined && toAge !== null)
      url_ += "toAge=" + encodeURIComponent("" + toAge) + "&";
    url_ = url_.replace(/[?&]$/, "");
 
    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingResponse[]
            >;
        })
      );
  }

  protected processGetBookings(
    response: HttpResponseBase
  ): Observable<BookingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingResponse[]>(null as any);
   
  }

  /**
   * Create a new booking, and apply all cached attachments from the user's current session to it.
   * @param req The new booking's details.
   * @return Successfully created a new booking
   */
  createBooking(req: BookingRequest): Observable<BookingResponse> {
    let url_ = this.baseUrl + "/api/Booking";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(req);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBooking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBooking(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BookingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BookingResponse>;
        })
      );
  }

  protected processCreateBooking(
    response: HttpResponseBase
  ): Observable<BookingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BookingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BookingResponse>(null as any);
  }

  /**
   * Get all bookings with a match on any word, for a given location.
   * @param loc (optional) The location's identifier (use 0 for all).
   * @param searchTerms (optional) A list of expressions to search for.
   * @param fromAge (optional) The minimum age of bookings (optional, in 'd.h:m:s.ms' format).
   * @param toAge (optional) The maximum age of bookings (optional, in 'd.h:m:s.ms' format).
   * @return Successful operation
   */
  searchBookings(
    loc: number | undefined,
    searchTerms: string[] | null | undefined,
    fromAge: string | null | undefined,
    toAge: string | null | undefined
  ): Observable<BookingResponse[]> {
    let url_ = this.baseUrl + "/api/Booking/Find?";
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    if (searchTerms !== undefined && searchTerms !== null)
      searchTerms &&
        searchTerms.forEach((item) => {
          url_ += "searchTerms=" + encodeURIComponent("" + item) + "&";
        });
    if (fromAge !== undefined && fromAge !== null)
      url_ += "fromAge=" + encodeURIComponent("" + fromAge) + "&";
    if (toAge !== undefined && toAge !== null)
      url_ += "toAge=" + encodeURIComponent("" + toAge) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchBookings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchBookings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingResponse[]
            >;
        })
      );
  }

  protected processSearchBookings(
    response: HttpResponseBase
  ): Observable<BookingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingResponse[]>(null as any);
   
  }

  /**
   * Log a duplicate booking.
   * @param req The new booking's details.
   * @return Successfully logged a new duplicate booking
   */
  logDuplicateBooking(req: BookingRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/Duplicate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(req);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLogDuplicateBooking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLogDuplicateBooking(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLogDuplicateBooking(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Create a new booking, anonymously.
   * @param req The new booking's details.
   * @return Successfully created a new booking
   */
  createBookingAnonymous(
    req: BookingRequestAnonymous
  ): Observable<BookingResponseAnonymous> {
    let url_ = this.baseUrl + "/api/Booking/Anonymous";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(req);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBookingAnonymous(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBookingAnonymous(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<BookingResponseAnonymous>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BookingResponseAnonymous>;
        })
      );
  }

  protected processCreateBookingAnonymous(
    response: HttpResponseBase
  ): Observable<BookingResponseAnonymous> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BookingResponseAnonymous.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters (CAPTCHA token specified in message may be invalid)",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BookingResponseAnonymous>(null as any);
  }

  /**
   * Get a booking's details.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  getBookingDetails(id: number): Observable<BookingResponse> {
    let url_ = this.baseUrl + "/api/Booking/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BookingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BookingResponse>;
        })
      );
  }

  protected processGetBookingDetails(
    response: HttpResponseBase
  ): Observable<BookingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BookingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Booking details could not be accessed",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BookingResponse>(null as any);
  }

  /**
   * Update a booking's details.
   * @param id The booking's identifier.
   * @param req The booking's details.
   * @return Successful operation
   */
  updateBookingDetails(
    id: number,
    req: BookingUpdateRequest
  ): Observable<BookingResponse> {
    let url_ = this.baseUrl + "/api/Booking/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(req);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBookingDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBookingDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BookingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BookingResponse>;
        })
      );
  }

  protected processUpdateBookingDetails(
    response: HttpResponseBase
  ): Observable<BookingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BookingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BookingResponse>(null as any);
  }

  /**
   * Get all logs for a given booking.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  getBookingLogs(id: number): Observable<LogResponse[]> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Log";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LogResponse[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LogResponse[]
            >;
        })
      );
  }

  protected processGetBookingLogs(
    response: HttpResponseBase
  ): Observable<LogResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LogResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LogResponse[]>(null as any);
  
  }

  /**
   * Get all note logs for a given booking.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  getNoteBookingLogs(id: number): Observable<LogResponse[]> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Log/Note";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNoteBookingLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNoteBookingLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LogResponse[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LogResponse[]
            >;
        })
      );
  }

  protected processGetNoteBookingLogs(
    response: HttpResponseBase
  ): Observable<LogResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LogResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LogResponse[]>(null as any);
   
  }

  /**
   * Add a note log to the given booking.
   * @param id The booking's identifier.
   * @param note The new note to be stored.
   * @return Successfully added a new note to the booking
   */
  createBookingNote(id: number, note: string): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Log/Note";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(note);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateBookingNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateBookingNote(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateBookingNote(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gets the number of Urgent bookings on a location.
   * @param locationId (optional) ID of the location (use 0 for all).
   * @param fromAge (optional) The minimum age of bookings (optional, in 'd.h:m:s.ms' format)
   * @param toAge (optional) The maximum age of bookings (optional, in 'd.h:m:s.ms' format)
   * @return Successful operation
   */
  getUrgentCount(
    locationId: number | undefined,
    fromAge: string | null | undefined,
    toAge: string | null | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + "/api/Booking/UrgentCount?";
    if (locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined)
      url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    if (fromAge !== undefined && fromAge !== null)
      url_ += "fromAge=" + encodeURIComponent("" + fromAge) + "&";
    if (toAge !== undefined && toAge !== null)
      url_ += "toAge=" + encodeURIComponent("" + toAge) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUrgentCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUrgentCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processGetUrgentCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * Gets the number of Bookings with an active SMS.
   * @param locationId (optional) ID of the location (use 0 for all).
   * @param fromAge (optional) The minimum age of bookings (optional, in 'd.h:m:s.ms' format)
   * @param toAge (optional) The maximum age of bookings (optional, in 'd.h:m:s.ms' format)
   * @return Successful operation
   */
  getSMSCount(
    locationId: number | undefined,
    fromAge: string | null | undefined,
    toAge: string | null | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + "/api/Booking/SMSCount?";
    if (locationId === null)
      throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined)
      url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    if (fromAge !== undefined && fromAge !== null)
      url_ += "fromAge=" + encodeURIComponent("" + fromAge) + "&";
    if (toAge !== undefined && toAge !== null)
      url_ += "toAge=" + encodeURIComponent("" + toAge) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSMSCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSMSCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processGetSMSCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * Mark a booking as 'won'.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  setBookingWon(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Status/Won";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetBookingWon(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetBookingWon(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSetBookingWon(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
  /**
   * Mark a booking as 'parked'.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  setBookingParked(id: number,reason:ParkedReasonRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Status/Park";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(reason);
  
      let options_: any = {
        body: content_,
        observe: "response",
        responseType: "blob",
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetBookingParked(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetBookingParked(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }
  protected processSetBookingParked(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Mark a booking as 'lost'.
   * @param id The booking's identifier.
   * @param reason The lost reason to be stored against the booking.
   * @return Successful operation
   */
  setBookingLost(id: number, reason: LostReasonRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Status/Lost";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(reason);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetBookingLost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetBookingLost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSetBookingLost(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Reopen a closed booking.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  reopenBooking(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/{id}/Status/Reopen";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReopenBooking(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReopenBooking(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processReopenBooking(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found, or is no longer active",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Send a batch of SMS messages.
   * @param sms The messages to be sent.
   * @return Successfully sent one or more SMS messages
   */
  sendBookingSMS(sms: SMSRequest[]): Observable<void> {
    let url_ = this.baseUrl + "/api/Booking/SMS";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(sms);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendBookingSMS(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendBookingSMS(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendBookingSMS(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ClickSendClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Send a SMS alert to support.
   * @param securitykey (optional) Security key.
   * @param timestamp (optional)
   * @param to (optional)
   * @param from (optional)
   * @param body (optional)
   * @param original_body (optional)
   * @param original_message_id (optional)
   * @param custom_string (optional)
   * @param user_id (optional)
   * @param subaccount_id (optional)
   * @param message_id (optional)
   * @return Successfully sent a SMS alert
   */
  logInboundSMS(
    securitykey: string | null | undefined,
    timestamp: number | undefined,
    to: string | null | undefined,
    from: string | null | undefined,
    body: string | null | undefined,
    original_body: string | null | undefined,
    original_message_id: string | null | undefined,
    custom_string: string | null | undefined,
    user_id: string | null | undefined,
    subaccount_id: string | null | undefined,
    message_id: string | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + "/api/ClickSend/SMS/Inbound?";
    if (securitykey !== undefined && securitykey !== null)
      url_ += "securitykey=" + encodeURIComponent("" + securitykey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (timestamp === null || timestamp === undefined)
      throw new Error("The parameter 'timestamp' cannot be null.");
    else content_.append("timestamp", timestamp.toString());
    if (to !== null && to !== undefined) content_.append("to", to.toString());
    if (from !== null && from !== undefined)
      content_.append("from", from.toString());
    if (body !== null && body !== undefined)
      content_.append("body", body.toString());
    if (original_body !== null && original_body !== undefined)
      content_.append("original_body", original_body.toString());
    if (original_message_id !== null && original_message_id !== undefined)
      content_.append("original_message_id", original_message_id.toString());
    if (custom_string !== null && custom_string !== undefined)
      content_.append("custom_string", custom_string.toString());
    if (user_id !== null && user_id !== undefined)
      content_.append("user_id", user_id.toString());
    if (subaccount_id !== null && subaccount_id !== undefined)
      content_.append("subaccount_id", subaccount_id.toString());
    if (message_id !== null && message_id !== undefined)
      content_.append("message_id", message_id.toString());

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLogInboundSMS(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLogInboundSMS(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLogInboundSMS(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class CompaniesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Gets all companies.
   * @return Successful operation
   */
  getCompanies(): Observable<CompanyResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Companies";
    url_ = url_.replace(/[?&]$/, "");
   
    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                CompanyResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              CompanyResponseSupport[]
            >;
        })
      );
  }

  protected processGetCompanies(
    response: HttpResponseBase
  ): Observable<CompanyResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(CompanyResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<CompanyResponseSupport[]>(null as any);
   
  }

  /**
   * Reassign the user to a different company.
   * @param id The company's identifier.
   * @return User changed to company
   */
  changeCompany(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Companies/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeCompany(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processChangeCompany(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The user or the specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class CompanyClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get the user's company details.
   * @return Successful operation
   */
  getCompany(): Observable<CompanyResponse> {
    let url_ = this.baseUrl + "/api/Company";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompany(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponse>;
        })
      );
  }

  protected processGetCompany(
    response: HttpResponseBase
  ): Observable<CompanyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No company information is associated with this user",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponse>(null as any);
  }

  /**
   * Update a user's company details.
   * @param id The company's identifier.
   * @param comp The company's details to update.
   * @return Successful operation
   */
  updateCompany(
    id: number,
    comp: CompanyUpdateRequest
  ): Observable<CompanyResponse> {
    let url_ = this.baseUrl + "/api/Company";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(comp);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCompany(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponse>;
        })
      );
  }

  protected processUpdateCompany(
    response: HttpResponseBase
  ): Observable<CompanyResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No company information is associated with this user",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponse>(null as any);
  }

  /**
   * Get the user's company details, anonymously.
   * @param key The company's unique key.
   * @return Successful operation
   */
  getCompanyAnonymous(
    key: string | null
  ): Observable<CompanyResponseAnonymous> {
    let url_ = this.baseUrl + "/api/Company/{key}";
    if (key === undefined || key === null)
      throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace("{key}", encodeURIComponent("" + key));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanyAnonymous(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanyAnonymous(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CompanyResponseAnonymous>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponseAnonymous>;
        })
      );
  }

  protected processGetCompanyAnonymous(
    response: HttpResponseBase
  ): Observable<CompanyResponseAnonymous> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponseAnonymous.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponseAnonymous>(null as any);
  }

  /**
   * Get a referring practice summary for a company (restricted).
   * @param id The company's identifier.
   * @return Successful operation
   */
  getRefPracticeSummary(id: number): Observable<ReferringPracticeResponse[]> {
    let url_ = this.baseUrl + "/api/Company/{id}/ReferringPractice";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRefPracticeSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRefPracticeSummary(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ReferringPracticeResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ReferringPracticeResponse[]
            >;
        })
      );
  }

  protected processGetRefPracticeSummary(
    response: HttpResponseBase
  ): Observable<ReferringPracticeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ReferringPracticeResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ReferringPracticeResponse[]>(null as any);
    
  }

  /**
   * Get recent referring practice activity for a company (restricted).
   * @param id The company's identifier.
   * @param name The referring practice's name (Base64 encoded).
   * @param amount (optional) Amount of records to return.
   * @return Successful operation
   */
  getRefPracticeRecent(
    id: number,
    name: string | null,
    amount: number | undefined
  ): Observable<ReferringPracticeResponse[]> {
    let url_ = this.baseUrl + "/api/Company/{id}/ReferringPractice/{name}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    if (amount === null)
      throw new Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined)
      url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRefPracticeRecent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRefPracticeRecent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ReferringPracticeResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ReferringPracticeResponse[]
            >;
        })
      );
  }

  protected processGetRefPracticeRecent(
    response: HttpResponseBase
  ): Observable<ReferringPracticeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ReferringPracticeResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ReferringPracticeResponse[]>(null as any);
    
  }

  /**
   * Get the user's company settings.
   * @return Successful operation
   */
  getSettingsAll(): Observable<SettingResponse[]> {
    let url_ = this.baseUrl + "/api/Company/Setting";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSettingsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSettingsAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                SettingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              SettingResponse[]
            >;
        })
      );
  }

  protected processGetSettingsAll(
    response: HttpResponseBase
  ): Observable<SettingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(SettingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<SettingResponse[]>(null as any);
   
  }

  /**
   * Get a company's settings (restricted).
   * @param id The company's identifier.
   * @return Successful operation
   */
  getSettings(id: number): Observable<SettingResponse[]> {
    let url_ = this.baseUrl + "/api/Company/{id}/Setting";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSettings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                SettingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              SettingResponse[]
            >;
        })
      );
  }

  protected processGetSettings(
    response: HttpResponseBase
  ): Observable<SettingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(SettingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<SettingResponse[]>(null as any);
   
  }

  /**
   * Update a user's company setting.
   * @param id The setting's identifier.
   * @param val The settings's new value.
   * @return Successful operation
   */
  updateSetting(id: number, val: string): Observable<SettingResponse> {
    let url_ = this.baseUrl + "/api/Company/Setting/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(val);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSetting(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSetting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SettingResponse>;
        })
      );
  }

  protected processUpdateSetting(
    response: HttpResponseBase
  ): Observable<SettingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SettingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified setting was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SettingResponse>(null as any);
  }

  /**
   * Update a company setting (restricted).
   * @param id The company's identifier.
   * @param id2 The setting's identifier.
   * @param val The settings's new value.
   * @return Successful operation
   */
  updateAnySetting(
    id: number,
    id2: number,
    val: string
  ): Observable<SettingResponse> {
    let url_ = this.baseUrl + "/api/Company/{id}/Setting/{id2}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (id2 === undefined || id2 === null)
      throw new Error("The parameter 'id2' must be defined.");
    url_ = url_.replace("{id2}", encodeURIComponent("" + id2));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(val);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAnySetting(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAnySetting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SettingResponse>;
        })
      );
  }

  protected processUpdateAnySetting(
    response: HttpResponseBase
  ): Observable<SettingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SettingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified setting was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SettingResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class DashboardClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get Dashboard data.
   * @return Successful operation
   */
  dashbaordInformation(): Observable<number[]> {
    let url_ = this.baseUrl + "/api/Dashboard";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDashbaordInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDashbaordInformation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number[]>;
        })
      );
  }

  protected processDashbaordInformation(
    response: HttpResponseBase
  ): Observable<number[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<number[]>(null as any);
   
  }

  /**
   * Get All graphs data.
   * @param loc (optional) The location's identifier (use 0 for all locations).
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getAllGraphs(
    loc: number | undefined,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<GraphDataResponse> {
    let url_ = this.baseUrl + "/api/Dashboard/Graphs?";
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllGraphs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllGraphs(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<GraphDataResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<GraphDataResponse>;
        })
      );
  }

  protected processGetAllGraphs(
    response: HttpResponseBase
  ): Observable<GraphDataResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GraphDataResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GraphDataResponse>(null as any);
  }

  /**
   * Get specified graph data.
   * @param id The type of summary data (use 0 for all summary data).
   * @param loc (optional) The location's identifier (use 0 for all locations).
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getGraph(
    id: number,
    loc: number | undefined,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<GraphDataResponse> {
    let url_ = this.baseUrl + "/api/Dashboard/Graphs/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGraph(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetGraph(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<GraphDataResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<GraphDataResponse>;
        })
      );
  }

  protected processGetGraph(
    response: HttpResponseBase
  ): Observable<GraphDataResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GraphDataResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GraphDataResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class LocationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a list of locations for the user.
   * @return Successful operation
   */
  getLocations(): Observable<LocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LocationResponse[]
            >;
        })
      );
  }

  protected processGetLocations(
    response: HttpResponseBase
  ): Observable<LocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LocationResponse[]>(null as any);
   
  }

  /**
   * Adds a Location.
   * @return Successfully created a new location
   */
  addLocation(newLocation: LocationRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Location";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(newLocation);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAddLocation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get a list of all locations for the user's company. (restricted).
   * @return Successful operation
   */
  getAllLocations(): Observable<LocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location/All";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LocationResponse[]
            >;
        })
      );
  }

  protected processGetAllLocations(
    response: HttpResponseBase
  ): Observable<LocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    
    return new Observable<LocationResponse[]>(null as any);
  }

  /**
   * Get a location's details (by its id).
   * @return Successful operation
   */
  getLocationById(id: number): Observable<LocationResponse> {
    let url_ = this.baseUrl + "/api/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LocationResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationResponse>;
        })
      );
  }

  protected processGetLocationById(
    response: HttpResponseBase
  ): Observable<LocationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationResponse>(null as any);
  }

  /**
   * Updates a Location.
   * @return Successfully updated a location
   */
  updateLocation(
    id: number,
    updateLocation: LocationUpdateRequest
  ): Observable<void> {
    let url_ = this.baseUrl + "/api/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(updateLocation);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateLocation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Removes a Location.
   * @param id The location identifier.
   * @return Successfully removed a user
   */
  removeLocation(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRemoveLocation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get a location's details (by its name).
   * @param name The location's name (Base64 encoded).
   * @return Successful operation
   */
  getLocationByName(name: string | null): Observable<LocationResponse> {
    let url_ = this.baseUrl + "/api/Location/{name}";
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationByName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationByName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LocationResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationResponse>;
        })
      );
  }

  protected processGetLocationByName(
    response: HttpResponseBase
  ): Observable<LocationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationResponse>(null as any);
  }

  /**
   * Assign a new location to the user.
   * @param locId The location identifier.
   * @param userId The user's identifier.
   * @return Successfully assigned a location to a user
   */
  addUserToLocation(
    locId: number,
    userId: number
  ): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location/{locId}/User/{userId}";
    if (locId === undefined || locId === null)
      throw new Error("The parameter 'locId' must be defined.");
    url_ = url_.replace("{locId}", encodeURIComponent("" + locId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddUserToLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddUserToLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processAddUserToLocation(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Set default location to the user.
   * @param locId The location identifier.
   * @param userId The user's identifier.
   * @return Successfully assigned default locatio to a user
   */
  setDefaultLocation(
    locId: number,
    userId: number
  ): Observable<UserLocationResponse> {
    let url_ = this.baseUrl + "/api/Location/{locId}/User/{userId}";
    if (locId === undefined || locId === null)
      throw new Error("The parameter 'locId' must be defined.");
    url_ = url_.replace("{locId}", encodeURIComponent("" + locId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetDefaultLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetDefaultLocation(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserLocationResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserLocationResponse>;
        })
      );
  }

  protected processSetDefaultLocation(
    response: HttpResponseBase
  ): Observable<UserLocationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserLocationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserLocationResponse>(null as any);
  }

  /**
   * Removes user from a location.
   * @param locId The location identifier.
   * @param userId The user's identifier.
   * @return Successfully remove a location from a user
   */
  removeUserFromLocation(
    locId: number,
    userId: number
  ): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location/{locId}/User/{userId}";
    if (locId === undefined || locId === null)
      throw new Error("The parameter 'locId' must be defined.");
    url_ = url_.replace("{locId}", encodeURIComponent("" + locId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveUserFromLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveUserFromLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processRemoveUserFromLocation(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result204: any = null;
          let resultData204 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData204)) {
            result204 = [] as any;
            for (let item of resultData204)
              result204!.push(UserLocationResponse.fromJS(item));
          } else {
            result204 = <any>null;
          }
          return _observableOf(result204);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Assign multiple locations to the user.
   * @param userId The user's identifier.
   * @return Successfully assigned multiple locations to a user
   */
  addUserToListOfLocations(
    idList: number[],
    userId: number
  ): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location/User/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(idList);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddUserToListOfLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddUserToListOfLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processAddUserToListOfLocations(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Remove multiple locations to the user.
   * @param userId The user's identifier.
   * @return Successfully removed multiple locations from a user
   */
  removeUserFromListOfLocations(
    idList: number[],
    userId: number
  ): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Location/User/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(idList);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveUserFromListOfLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveUserFromListOfLocations(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processRemoveUserFromListOfLocations(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Get a list of aliased locations for the user.
   * @param alias (optional) The alias group ID.
   * @return Successful operation
   */
  getLocationsAlias(
    alias: string | null | undefined
  ): Observable<LocationAliasResponse[]> {
    let url_ = this.baseUrl + "/api/Location/Alias?";
    if (alias !== undefined && alias !== null)
      url_ += "alias=" + encodeURIComponent("" + alias) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationsAlias(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationsAlias(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LocationAliasResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LocationAliasResponse[]
            >;
        })
      );
  }

  protected processGetLocationsAlias(
    response: HttpResponseBase
  ): Observable<LocationAliasResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LocationAliasResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LocationAliasResponse[]>(null as any);
  }

  /**
   * Get a location's settings.
   * @param id The location's identifier.
   * @return Successful operation
   */
  getSettings(id: number): Observable<SettingResponse[]> {
    let url_ = this.baseUrl + "/api/Location/{id}/Setting";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSettings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                SettingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              SettingResponse[]
            >;
        })
      );
  }

  protected processGetSettings(
    response: HttpResponseBase
  ): Observable<SettingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(SettingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<SettingResponse[]>(null as any);
  }

  /**
   * Update a location setting.
   * @param id The setting's identifier.
   * @param loc (optional) The location the setting is for.
   * @param val The settings's new value.
   * @return Successful operation
   */
  updateSetting(
    id: number,
    loc: number | undefined,
    val: string
  ): Observable<SettingResponse> {
    let url_ = this.baseUrl + "/api/Location/setting/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(val);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSetting(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSetting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SettingResponse>;
        })
      );
  }

  protected processUpdateSetting(
    response: HttpResponseBase
  ): Observable<SettingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SettingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified setting was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SettingResponse>(null as any);
  }

  /**
   * Get a location's SMS placeholder values.
   * @param id The location's identifier.
   * @return Successful operation
   */
  getSMSPlaceholderValues(
    id: number
  ): Observable<KeyValuePairOfStringAndString[]> {
    let url_ = this.baseUrl + "/api/Location/{id}/SMSPlaceholder";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSMSPlaceholderValues(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSMSPlaceholderValues(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                KeyValuePairOfStringAndString[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              KeyValuePairOfStringAndString[]
            >;
        })
      );
  }

  protected processGetSMSPlaceholderValues(
    response: HttpResponseBase
  ): Observable<KeyValuePairOfStringAndString[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(KeyValuePairOfStringAndString.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<KeyValuePairOfStringAndString[]>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class LostReasonClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get the list of lost reasons.
   * @return Successful operation
   */
  getLostReason(): Observable<LostReasonResponse[]> {
    let url_ = this.baseUrl + "/api/LostReason";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLostReason(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLostReason(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LostReasonResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LostReasonResponse[]
            >;
        })
      );
  }

  protected processGetLostReason(
    response: HttpResponseBase
  ): Observable<LostReasonResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LostReasonResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LostReasonResponse[]>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ParkedReasonClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get the list of lost reasons.
   * @return Successful operation
   */
  getLostReason(): Observable<LostReasonResponse[]> {
    let url_ = this.baseUrl + "/api/ParkReason";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLostReason(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLostReason(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LostReasonResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LostReasonResponse[]
            >;
        })
      );
  }

  protected processGetLostReason(
    response: HttpResponseBase
  ): Observable<LostReasonResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LostReasonResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LostReasonResponse[]>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ReferringPracticeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a referring practice's usage summary across all companies.
   * @param name The referring practice's name (Base64 encoded).
   * @return Successful operation
   */
  getReferringPracticeUsage(
    name: string | null
  ): Observable<ReferringPracticeUageResponse> {
    let url_ = this.baseUrl + "/api/ReferringPractice/{name}/Usage";
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReferringPracticeUsage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReferringPracticeUsage(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ReferringPracticeUageResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ReferringPracticeUageResponse>;
        })
      );
  }

  protected processGetReferringPracticeUsage(
    response: HttpResponseBase
  ): Observable<ReferringPracticeUageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferringPracticeUageResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified referring practice was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReferringPracticeUageResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ReferringPracticeLookupClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a list of referring practice lookups.
   * @param code (optional) A referring practice code (optional).
   * @return Successful operation
   */
  geReferringPracticeLookupsList(
    code: string | null | undefined
  ): Observable<ReferringPracticeLookupResponse[]> {
    let url_ = this.baseUrl + "/api/ReferringPracticeLookup?";
    if (code !== undefined && code !== null)
      url_ += "code=" + encodeURIComponent("" + code) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeReferringPracticeLookupsList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeReferringPracticeLookupsList(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ReferringPracticeLookupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ReferringPracticeLookupResponse[]
            >;
        })
      );
  }

  protected processGeReferringPracticeLookupsList(
    response: HttpResponseBase
  ): Observable<ReferringPracticeLookupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ReferringPracticeLookupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ReferringPracticeLookupResponse[]>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ReminderClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get all reminders on a User.
   * @return Successful operation
   */
  getReminders(): Observable<ReminderResponse[]> {
    let url_ = this.baseUrl + "/api/Reminder";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReminders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReminders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ReminderResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ReminderResponse[]
            >;
        })
      );
  }

  protected processGetReminders(
    response: HttpResponseBase
  ): Observable<ReminderResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ReminderResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ReminderResponse[]>(null as any);
  }

  /**
   * Update a booking's reminder.
   * @param id The booking's identifier.
   * @param reminderUpdate The new date time for the reminder.
   * @return Successful operation
   */
  updateReminder(id: number, reminderUpdate: Date): Observable<void> {
    let url_ = this.baseUrl + "/api/Reminder/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(reminderUpdate);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateReminder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateReminder(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateReminder(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Clear a booking's reminder.
   * @param id The booking's identifier.
   * @return Successful operation
   */
  clearBookingReminder(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Reminder/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearBookingReminder(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearBookingReminder(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processClearBookingReminder(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified booking was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ReportClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a list of available reports.
   * @return Successful operation
   */
  getReportList(): Observable<ReportResponse[]> {
    let url_ = this.baseUrl + "/api/Report";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReportResponse[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ReportResponse[]
            >;
        })
      );
  }

  protected processGetReportList(
    response: HttpResponseBase
  ): Observable<ReportResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ReportResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ReportResponse[]>(null as any);
  }

  /**
   * Get report data in tabular format.
   * @param id The report's identifier.
   * @param loc (optional) The location's identifier (use 0 for all locations).
   * @param overdue (optional) The number of hours overdue (ignored if not applicable).
   * @param fromDate (optional) Start of date/time range (ignored if not applicable).
   * @param toDate (optional) End of date/time range (ignored if not applicable).
   * @return Successful operation
   */
  getReportData(
    id: number,
    loc: number | undefined,
    overdue: number | null | undefined,
    fromDate: Date | null | undefined,
    toDate: Date | null | undefined
  ): Observable<ReportDataResponse> {
    let url_ = this.baseUrl + "/api/Report/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    if (overdue !== undefined && overdue !== null)
      url_ += "overdue=" + encodeURIComponent("" + overdue) + "&";
    if (fromDate !== undefined && fromDate !== null)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate !== undefined && toDate !== null)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReportData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReportData(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ReportDataResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ReportDataResponse>;
        })
      );
  }

  protected processGetReportData(
    response: HttpResponseBase
  ): Observable<ReportDataResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReportDataResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified report or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReportDataResponse>(null as any);
  }

  /**
   * Get report data in CSV format.
   * @param id The report's identifier.
   * @param loc (optional) The location's identifier (use 0 for all locations).
   * @param overdue (optional) The number of hours overdue (ignored if not applicable).
   * @param fromDate (optional) Start of date/time range (ignored if not applicable).
   * @param toDate (optional) End of date/time range (ignored if not applicable).
   * @return Successful operation
   */
  getCSVData(
    id: number,
    loc: number | undefined,
    overdue: number | null | undefined,
    fromDate: Date | null | undefined,
    toDate: Date | null | undefined
  ): Observable<string> {
    let url_ = this.baseUrl + "/api/Report/{id}/CSV?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (loc === null) throw new Error("The parameter 'loc' cannot be null.");
    else if (loc !== undefined)
      url_ += "loc=" + encodeURIComponent("" + loc) + "&";
    if (overdue !== undefined && overdue !== null)
      url_ += "overdue=" + encodeURIComponent("" + overdue) + "&";
    if (fromDate !== undefined && fromDate !== null)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate !== undefined && toDate !== null)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCSVData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCSVData(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processGetCSVData(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified report or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class RoleClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a list of roles.
   * @return Successful operation
   */
  get(): Observable<RoleResponse[]> {
    let url_ = this.baseUrl + "/api/Role";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleResponse[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              RoleResponse[]
            >;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<RoleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(RoleResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<RoleResponse[]>(null as any);
  }

  /**
   * Update a user's role.
   * @return Successful operation
   */
  updateUserRole(roleid: number, userid: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Role/{roleid}/user/{userid}";
    if (roleid === undefined || roleid === null)
      throw new Error("The parameter 'roleid' must be defined.");
    url_ = url_.replace("{roleid}", encodeURIComponent("" + roleid));
    if (userid === undefined || userid === null)
      throw new Error("The parameter 'userid' must be defined.");
    url_ = url_.replace("{userid}", encodeURIComponent("" + userid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateUserRole(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User or Role not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class ServiceClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get all services.
   * @return Successful operation
   */
  getServices(): Observable<ServiceResponse[]> {
    let url_ = this.baseUrl + "/api/Service";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetServices(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetServices(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ServiceResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ServiceResponse[]
            >;
        })
      );
  }

  protected processGetServices(
    response: HttpResponseBase
  ): Observable<ServiceResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ServiceResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<ServiceResponse[]>(null as any);
  }

  /**
   * Get a service's details.
   * @param id The service's identifier.
   * @return Successful operation
   */
  getServiceDetails(id: number): Observable<ServiceResponse> {
    let url_ = this.baseUrl + "/api/Service/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetServiceDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetServiceDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ServiceResponse>;
        })
      );
  }

  protected processGetServiceDetails(
    response: HttpResponseBase
  ): Observable<ServiceResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified service was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ServiceResponse>(null as any);
  }

  /**
   * Update a service's details.
   * @param id The service's identifier.
   * @param serv The service's details to update.
   * @return Successful operation
   */
  updateServiceDetails(
    id: number,
    serv: ServiceRequest
  ): Observable<ServiceResponse> {
    let url_ = this.baseUrl + "/api/Service/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(serv);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateServiceDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateServiceDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ServiceResponse>;
        })
      );
  }

  protected processUpdateServiceDetails(
    response: HttpResponseBase
  ): Observable<ServiceResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified service was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ServiceResponse>(null as any);
  }

  /**
   * Snooze alerts for a service's details.
   * @param id The service's identifier.
   * @param mins The number of minutes to snooze alerts.
   * @return Successful operation
   */
  snoozeServiceAlerts(id: number, mins: number): Observable<ServiceResponse> {
    let url_ = this.baseUrl + "/api/Service/{id}/Snooze/{mins}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (mins === undefined || mins === null)
      throw new Error("The parameter 'mins' must be defined.");
    url_ = url_.replace("{mins}", encodeURIComponent("" + mins));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSnoozeServiceAlerts(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSnoozeServiceAlerts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ServiceResponse>;
        })
      );
  }

  protected processSnoozeServiceAlerts(
    response: HttpResponseBase
  ): Observable<ServiceResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified service was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ServiceResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class SupportClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Find bookings across entire system.
   * @param id (optional) The id of the booking (0 to exclude, other parameters ignored if used).
   * @param fname (optional) The first name (optional, wildcards excepted).
   * @param lname (optional) The last name (optional, wildcards excepted).
   * @param contact (optional) A phone/email (optional, wildcards excepted).
   * @return Successful operation
   */
  findBookings(
    id: number | undefined,
    fname: string | null | undefined,
    lname: string | null | undefined,
    contact: string | null | undefined
  ): Observable<BookingSearchResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/Booking/Search?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (fname !== undefined && fname !== null)
      url_ += "fname=" + encodeURIComponent("" + fname) + "&";
    if (lname !== undefined && lname !== null)
      url_ += "lname=" + encodeURIComponent("" + lname) + "&";
    if (contact !== undefined && contact !== null)
      url_ += "contact=" + encodeURIComponent("" + contact) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindBookings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindBookings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingSearchResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingSearchResponseSupport[]
            >;
        })
      );
  }

  protected processFindBookings(
    response: HttpResponseBase
  ): Observable<BookingSearchResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingSearchResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingSearchResponseSupport[]>(null as any);
  }

  /**
   * List bookings across entire system without any SMSs logged.
   * @param fromId (optional) The first booking id in the range.
   * @param toId (optional) The last booking id in the range.
   * @param status (optional) The statuses to limit bookings to (optional).
   * @return Successful operation
   */
  noSMSBookings(
    fromId: number | undefined,
    toId: number | undefined,
    status: string | null | undefined
  ): Observable<BookingNoSMSResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/Booking/NoSMS?";
    if (fromId === null)
      throw new Error("The parameter 'fromId' cannot be null.");
    else if (fromId !== undefined)
      url_ += "fromId=" + encodeURIComponent("" + fromId) + "&";
    if (toId === null) throw new Error("The parameter 'toId' cannot be null.");
    else if (toId !== undefined)
      url_ += "toId=" + encodeURIComponent("" + toId) + "&";
    if (status !== undefined && status !== null)
      url_ += "status=" + encodeURIComponent("" + status) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNoSMSBookings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNoSMSBookings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingNoSMSResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingNoSMSResponseSupport[]
            >;
        })
      );
  }

  protected processNoSMSBookings(
    response: HttpResponseBase
  ): Observable<BookingNoSMSResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingNoSMSResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingNoSMSResponseSupport[]>(null as any);
  }

  /**
   * Get all companies.
   * @return Successful operation
   */
  getCompanies(): Observable<CompanyResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/Company";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                CompanyResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              CompanyResponseSupport[]
            >;
        })
      );
  }

  protected processGetCompanies(
    response: HttpResponseBase
  ): Observable<CompanyResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(CompanyResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<CompanyResponseSupport[]>(null as any);
  }

  /**
   * Create a new company.
   * @param comp The new company's details.
   * @return Successfully created a new company
   */
  createCompany(comp: CompanyRequest): Observable<CompanyResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Company";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(comp);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCompany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCompany(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CompanyResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponseSupport>;
        })
      );
  }

  protected processCreateCompany(
    response: HttpResponseBase
  ): Observable<CompanyResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponseSupport>(null as any);
  }

  /**
   * Get a company's details.
   * @param id The company's identifier.
   * @return Successful operation
   */
  getCompanyDetails(id: number): Observable<CompanyResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Company/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanyDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanyDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CompanyResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponseSupport>;
        })
      );
  }

  protected processGetCompanyDetails(
    response: HttpResponseBase
  ): Observable<CompanyResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponseSupport>(null as any);
  }

  /**
   * Update a company's details.
   * @param id The company's identifier.
   * @param comp The company's details to update.
   * @return Successful operation
   */
  updateCompanyDetails(
    id: number,
    comp: CompanyUpdateRequestSupport
  ): Observable<CompanyResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Company/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(comp);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCompanyDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCompanyDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CompanyResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CompanyResponseSupport>;
        })
      );
  }

  protected processUpdateCompanyDetails(
    response: HttpResponseBase
  ): Observable<CompanyResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CompanyResponseSupport>(null as any);
  }

  /**
   * Get a company's summary data.
   * @param id The company's identifier.
   * @param typ (optional) The type of summary data.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getCompanySummaryDetails(
    id: number,
    typ: string | null | undefined,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<BookingSummaryResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Company/{id}/Summary?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (typ !== undefined && typ !== null)
      url_ += "typ=" + encodeURIComponent("" + typ) + "&";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanySummaryDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanySummaryDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingSummaryResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingSummaryResponse[]
            >;
        })
      );
  }

  protected processGetCompanySummaryDetails(
    response: HttpResponseBase
  ): Observable<BookingSummaryResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingSummaryResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingSummaryResponse[]>(null as any);
  }

  /**
   * Get a company's breakup data.
   * @param id The company's identifier.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getCompanyBreakupDetails(
    id: number,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<BookingBreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Company/{id}/Breakup?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanyBreakupDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanyBreakupDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BookingBreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BookingBreakupResponse[]
            >;
        })
      );
  }

  protected processGetCompanyBreakupDetails(
    response: HttpResponseBase
  ): Observable<BookingBreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BookingBreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BookingBreakupResponse[]>(null as any);
  }

  /**
   * Get a company's SMS usage summary data.
   * @param id The company's identifier.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getCompanySMSUsageSummary(
    id: number,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<SMSSummaryResponse> {
    let url_ = this.baseUrl + "/api/Support/Company/{id}/SMS/Summary?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompanySMSUsageSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompanySMSUsageSummary(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<SMSSummaryResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SMSSummaryResponse>;
        })
      );
  }

  protected processGetCompanySMSUsageSummary(
    response: HttpResponseBase
  ): Observable<SMSSummaryResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SMSSummaryResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SMSSummaryResponse>(null as any);
  }

  /**
   * Get company locations.
   * @param comp (optional) A company's identifier (optional).
   * @return Successful operation
   */
  getLocations(
    comp: number | undefined
  ): Observable<LocationResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/Location?";
    if (comp === null) throw new Error("The parameter 'comp' cannot be null.");
    else if (comp !== undefined)
      url_ += "comp=" + encodeURIComponent("" + comp) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LocationResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LocationResponseSupport[]
            >;
        })
      );
  }

  protected processGetLocations(
    response: HttpResponseBase
  ): Observable<LocationResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LocationResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LocationResponseSupport[]>(null as any);
  }

  /**
   * Create a new company location.
   * @param loc The new location's details.
   * @return Successfully created a new location
   */
  createLocation(loc: LocationRequest): Observable<LocationResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Location";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(loc);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateLocation(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationResponseSupport>;
        })
      );
  }

  protected processCreateLocation(
    response: HttpResponseBase
  ): Observable<LocationResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company location name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationResponseSupport>(null as any);
  }

  /**
   * Get a location's details.
   * @param id The location's identifier.
   * @return Successful operation
   */
  getLocationDetails(id: number): Observable<LocationResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationResponseSupport>;
        })
      );
  }

  protected processGetLocationDetails(
    response: HttpResponseBase
  ): Observable<LocationResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationResponseSupport>(null as any);
  }

  /**
   * Update a location's details.
   * @param id The location's identifier.
   * @param loc The location's details to update.
   * @return Successful operation
   */
  updateLocationDetails(
    id: number,
    loc: LocationUpdateRequest
  ): Observable<LocationResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(loc);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateLocationDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateLocationDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationResponseSupport>;
        })
      );
  }

  protected processUpdateLocationDetails(
    response: HttpResponseBase
  ): Observable<LocationResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationResponseSupport>(null as any);
  }

  /**
   * Get a location's SMS usage summary data.
   * @param id The location's identifier.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getLocationSMSUsageSummary(
    id: number,
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<SMSSummaryResponse> {
    let url_ = this.baseUrl + "/api/Support/Location/{id}/SMS/Summary?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationSMSUsageSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationSMSUsageSummary(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<SMSSummaryResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SMSSummaryResponse>;
        })
      );
  }

  protected processGetLocationSMSUsageSummary(
    response: HttpResponseBase
  ): Observable<SMSSummaryResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SMSSummaryResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SMSSummaryResponse>(null as any);
  }

  /**
   * Return the most recent booking logs from across all customers.
   * @param typ (optional) The type of logs to return (optional).
   * @param limit (optional) The maximum records to return (defaults to 100).
   * @return Successful operation
   */
  getRecentLogs(
    typ: string | null | undefined,
    limit: number | undefined
  ): Observable<LogResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/Log/Recent?";
    if (typ !== undefined && typ !== null)
      url_ += "typ=" + encodeURIComponent("" + typ) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRecentLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRecentLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LogResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LogResponseSupport[]
            >;
        })
      );
  }

  protected processGetRecentLogs(
    response: HttpResponseBase
  ): Observable<LogResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(LogResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<LogResponseSupport[]>(null as any);
  }

  /**
   * Find recently used referring practices across the entire system.
   * @param name (optional) The name of a referring practice (wildcards excepted).
   * @return Successful operation
   */
  findReferringPractice(name: string | null | undefined): Observable<string[]> {
    let url_ = this.baseUrl + "/api/Support/ReferringPractice/Search?";
    if (name !== undefined && name !== null)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindReferringPractice(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindReferringPractice(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processFindReferringPractice(
    response: HttpResponseBase
  ): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<string[]>(null as any);
  }

  /**
   * Get recent referring practice activity.
   * @param name The referring practice's name (Base64 encoded).
   * @param timeOffset (optional) The time offset (in hours) of the timezone you want data based on.
   * @param noDays (optional) Number of days of request totals to return.
   * @return Successful operation
   */
  getRefPracticeSummary(
    name: string | null,
    timeOffset: number | undefined,
    noDays: number | undefined
  ): Observable<string[][]> {
    let url_ = this.baseUrl + "/api/Support/ReferringPractice/{name}/Summary?";
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    if (timeOffset === null)
      throw new Error("The parameter 'timeOffset' cannot be null.");
    else if (timeOffset !== undefined)
      url_ += "timeOffset=" + encodeURIComponent("" + timeOffset) + "&";
    if (noDays === null)
      throw new Error("The parameter 'noDays' cannot be null.");
    else if (noDays !== undefined)
      url_ += "noDays=" + encodeURIComponent("" + noDays) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRefPracticeSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRefPracticeSummary(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[][]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<string[][]>;
        })
      );
  }

  protected processGetRefPracticeSummary(
    response: HttpResponseBase
  ): Observable<string[][]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<string[][]>(null as any);
  }

  /**
   * Create a new referring practice lookup.
   * @param refprac The referring practice's details.
   * @return Successfully created a new referring practice lookup entry
   */
  createRefPracLookup(
    refprac: ReferringPracticeLookupRequest
  ): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/ReferringPracticeLookup";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(refprac);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateRefPracLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateRefPracLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateRefPracLookup(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified referring practice code already exists",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get users.
   * @param comp (optional) The company's identifier (optional).
   * @return Successful operation
   */
  getUsers(comp: number | undefined): Observable<UserResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/User?";
    if (comp === null) throw new Error("The parameter 'comp' cannot be null.");
    else if (comp !== undefined)
      url_ += "comp=" + encodeURIComponent("" + comp) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserResponseSupport[]
            >;
        })
      );
  }

  protected processGetUsers(
    response: HttpResponseBase
  ): Observable<UserResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserResponseSupport[]>(null as any);
  }

  /**
   * Create a new user.
   * @param usr The new user's details.
   * @return Successfully created a new user
   */
  createUser(usr: UserRequest): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/User";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(usr);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUser(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processCreateUser(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified email address is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Get a user's details.
   * @param id The user's identifier.
   * @return Successful operation
   */
  getUserDetails(id: number): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/User/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processGetUserDetails(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Update a user's details.
   * @param id The user's identifier.
   * @param usr The user's details to update.
   * @return Successful operation
   */
  updateUserDetails(
    id: number,
    usr: UserUpdateRequest
  ): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Support/User/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(usr);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processUpdateUserDetails(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified email address is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Get a user's locations.
   * @param id The user's identifier.
   * @return Successful operation
   */
  getUserLocations(id: number): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Location";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processGetUserLocations(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Assign a new location to the user.
   * @param id The user's identifier.
   * @param id2 The location identifier.
   * @return Successfully assigned a location to a user
   */
  createUserLocation(id: number, id2: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Location/{id2}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (id2 === undefined || id2 === null)
      throw new Error("The parameter 'id2' must be defined.");
    url_ = url_.replace("{id2}", encodeURIComponent("" + id2));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUserLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateUserLocation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user location is already assigned",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Update a user location's details.
   * @param id The user's identifier.
   * @param id2 The location identifier.
   * @param def The user location's new default value.
   * @return Successful operation
   */
  updateUserLocationDetails(
    id: number,
    id2: number,
    def: boolean
  ): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Location/{id2}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (id2 === undefined || id2 === null)
      throw new Error("The parameter 'id2' must be defined.");
    url_ = url_.replace("{id2}", encodeURIComponent("" + id2));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(def);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserLocationDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserLocationDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateUserLocationDetails(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user or location was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Delete a location from the user.
   * @param id The user's identifier.
   * @param id2 The location identifier.
   * @return Successfully deleted the user location
   */
  deleteUserLocation(id: number, id2: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Location/{id2}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (id2 === undefined || id2 === null)
      throw new Error("The parameter 'id2' must be defined.");
    url_ = url_.replace("{id2}", encodeURIComponent("" + id2));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserLocation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUserLocation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteUserLocation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get a user's login records.
   * @param id The user's identifier.
   * @return Successful operation
   */
  getUserLogins(id: number): Observable<UserLoginResponse[]> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Login";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserLogins(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserLogins(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLoginResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLoginResponse[]
            >;
        })
      );
  }

  protected processGetUserLogins(
    response: HttpResponseBase
  ): Observable<UserLoginResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLoginResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLoginResponse[]>(null as any);
  }

  /**
   * Delete a user's login records.
   * @param id The user's identifier.
   * @return Successfully deleted a user's logins
   */
  deleteUserLogins(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/Login";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserLogins(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUserLogins(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteUserLogins(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get a user's SUK records.
   * @param id The user's identifier.
   * @return Successful operation
   */
  getUserSUKs(id: number): Observable<SingleUseKeyResponse[]> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/SUK";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserSUKs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserSUKs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                SingleUseKeyResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              SingleUseKeyResponse[]
            >;
        })
      );
  }

  protected processGetUserSUKs(
    response: HttpResponseBase
  ): Observable<SingleUseKeyResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(SingleUseKeyResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<SingleUseKeyResponse[]>(null as any);
  }

  /**
   * Delete a user's SUK records.
   * @param id The user's identifier.
   * @return Successfully deleted a user's SUKs
   */
  deleteUserSUKs(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/User/{id}/SUK";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserSUKs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUserSUKs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteUserSUKs(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Find users across entire system.
   * @param fname (optional) The user's first name (optional, wildcards excepted).
   * @param lname (optional) The user's last name (optional, wildcards excepted).
   * @param email (optional) The user's email (optional, wildcards excepted).
   * @param hassuk (optional) Has one or more SUKs assigned to them (optional).
   * @return Successful operation
   */
  findUsers(
    fname: string | null | undefined,
    lname: string | null | undefined,
    email: string | null | undefined,
    hassuk: boolean | undefined
  ): Observable<UserResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Support/User/Search?";
    if (fname !== undefined && fname !== null)
      url_ += "fname=" + encodeURIComponent("" + fname) + "&";
    if (lname !== undefined && lname !== null)
      url_ += "lname=" + encodeURIComponent("" + lname) + "&";
    if (email !== undefined && email !== null)
      url_ += "email=" + encodeURIComponent("" + email) + "&";
    if (hassuk === null)
      throw new Error("The parameter 'hassuk' cannot be null.");
    else if (hassuk !== undefined)
      url_ += "hassuk=" + encodeURIComponent("" + hassuk) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserResponseSupport[]
            >;
        })
      );
  }

  protected processFindUsers(
    response: HttpResponseBase
  ): Observable<UserResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserResponseSupport[]>(null as any);
  }

  /**
   * Get all aliases.
   * @return Successful operation
   */
  getAliases(): Observable<AliasResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Alias";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAliases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAliases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AliasResponse[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              AliasResponse[]
            >;
        })
      );
  }

  protected processGetAliases(
    response: HttpResponseBase
  ): Observable<AliasResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(AliasResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<AliasResponse[]>(null as any);
  }

  /**
   * Create a new alias.
   * @param alias The new alias' details.
   * @return Successfully created a new alias
   */
  createAlias(alias: AliasRequest): Observable<AliasResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(alias);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateAlias(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateAlias(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AliasResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AliasResponse>;
        })
      );
  }

  protected processCreateAlias(
    response: HttpResponseBase
  ): Observable<AliasResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AliasResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AliasResponse>(null as any);
  }

  /**
   * Get an alias' details.
   * @param id The alias' identifier.
   * @return Successful operation
   */
  getAliasDetails(id: number): Observable<AliasDetailResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAliasDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAliasDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AliasDetailResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AliasDetailResponse>;
        })
      );
  }

  protected processGetAliasDetails(
    response: HttpResponseBase
  ): Observable<AliasDetailResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AliasDetailResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AliasDetailResponse>(null as any);
  }

  /**
   * Update an alias' details.
   * @param id The alias' identifier.
   * @param alias The alias' details to update.
   * @return Successful operation
   */
  updateAliasDetails(
    id: number,
    alias: AliasRequest
  ): Observable<AliasResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(alias);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAliasDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAliasDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AliasResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AliasResponse>;
        })
      );
  }

  protected processUpdateAliasDetails(
    response: HttpResponseBase
  ): Observable<AliasResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AliasResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "No updated content was specified",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AliasResponse>(null as any);
  }

  /**
   * Delete an alias.
   * @param id The alias' identifier.
   * @return Successfully deleted the alias
   */
  deleteAlias(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/Alias/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAlias(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAlias(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteAlias(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Create a new location alias.
   * @param id The alias' identifier.
   * @param loca The new location alias' details.
   * @return Successfully created a new location
   */
  createLocationAlias(
    id: number,
    loca: LocationAliasRequest
  ): Observable<LocationAliasResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias/{id}/Location";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(loca);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateLocationAlias(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateLocationAlias(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationAliasResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationAliasResponse>;
        })
      );
  }

  protected processCreateLocationAlias(
    response: HttpResponseBase
  ): Observable<LocationAliasResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationAliasResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location alias name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationAliasResponse>(null as any);
  }

  /**
   * Get a location alias' details.
   * @param id The location alias' identifier.
   * @return Successful operation
   */
  getLocationAliasDetails(id: number): Observable<LocationAliasResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLocationAliasDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLocationAliasDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationAliasResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationAliasResponse>;
        })
      );
  }

  protected processGetLocationAliasDetails(
    response: HttpResponseBase
  ): Observable<LocationAliasResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationAliasResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationAliasResponse>(null as any);
  }

  /**
   * Update a location alias' details.
   * @param id The location alias' identifier.
   * @param alias The location alias' details to update.
   * @return Successful operation
   */
  updateLocationAliasDetails(
    id: number,
    alias: LocationAliasUpdateRequest
  ): Observable<LocationAliasResponse> {
    let url_ = this.baseUrl + "/api/Support/Alias/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(alias);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateLocationAliasDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateLocationAliasDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LocationAliasResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LocationAliasResponse>;
        })
      );
  }

  protected processUpdateLocationAliasDetails(
    response: HttpResponseBase
  ): Observable<LocationAliasResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationAliasResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location alias name is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LocationAliasResponse>(null as any);
  }

  /**
   * Delete a location alias.
   * @param id The location alias' identifier.
   * @return Successfully deleted the location alias
   */
  deleteLocationAlias(id: number): Observable<void> {
    let url_ = this.baseUrl + "/api/Support/Alias/Location/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteLocationAlias(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteLocationAlias(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteLocationAlias(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified location alias was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get summary of all eReferrers across all companies.
   * @return Successful operation
   */
  geteReferralsSummary(): Observable<EReferralResponse[]> {
    let url_ = this.baseUrl + "/api/Support/eReferrals/Summary";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeteReferralsSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeteReferralsSummary(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                EReferralResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              EReferralResponse[]
            >;
        })
      );
  }

  protected processGeteReferralsSummary(
    response: HttpResponseBase
  ): Observable<EReferralResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(EReferralResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<EReferralResponse[]>(null as any);
  }

  /**
   * Get an overview of bookings across all billable customers.
   * @param timeOffset (optional) The time offset (in hours) of the timezone you want data based on.
   * @return Successful operation
   */
  getBookingsOverview(
    timeOffset: number | undefined
  ): Observable<BookingsOverviewResponse> {
    let url_ = this.baseUrl + "/api/Support/Overview/Bookings?";
    if (timeOffset === null)
      throw new Error("The parameter 'timeOffset' cannot be null.");
    else if (timeOffset !== undefined)
      url_ += "timeOffset=" + encodeURIComponent("" + timeOffset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingsOverview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingsOverview(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<BookingsOverviewResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<BookingsOverviewResponse>;
        })
      );
  }

  protected processGetBookingsOverview(
    response: HttpResponseBase
  ): Observable<BookingsOverviewResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BookingsOverviewResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<BookingsOverviewResponse>(null as any);
  }

  /**
   * Get an overview of open bookings across all billable customers.
   * @return Successful operation
   */
  getOpenBookingsOverview(): Observable<OpenRequestsOverviewResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Overview/Open";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOpenBookingsOverview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOpenBookingsOverview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                OpenRequestsOverviewResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              OpenRequestsOverviewResponse[]
            >;
        })
      );
  }

  protected processGetOpenBookingsOverview(
    response: HttpResponseBase
  ): Observable<OpenRequestsOverviewResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(OpenRequestsOverviewResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<OpenRequestsOverviewResponse[]>(null as any);
  }

  /**
   * Get an overview of revenue across all billable customers.
   * @return Successful operation
   */
  getRevenueOverview(): Observable<RevenueOverviewResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Overview/Revenue";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRevenueOverview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRevenueOverview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                RevenueOverviewResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              RevenueOverviewResponse[]
            >;
        })
      );
  }

  protected processGetRevenueOverview(
    response: HttpResponseBase
  ): Observable<RevenueOverviewResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(RevenueOverviewResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<RevenueOverviewResponse[]>(null as any);
  }

  /**
   * Get an overview of blocked duplicate bookings.
   * @param timeOffset (optional) The time offset (in hours) of the timezone you want data based on.
   * @return Successful operation
   */
  getDuplicatesOverview(
    timeOffset: number | undefined
  ): Observable<DuplicateOverviewResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Overview/Duplicates?";
    if (timeOffset === null)
      throw new Error("The parameter 'timeOffset' cannot be null.");
    else if (timeOffset !== undefined)
      url_ += "timeOffset=" + encodeURIComponent("" + timeOffset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDuplicatesOverview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDuplicatesOverview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                DuplicateOverviewResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              DuplicateOverviewResponse[]
            >;
        })
      );
  }

  protected processGetDuplicatesOverview(
    response: HttpResponseBase
  ): Observable<DuplicateOverviewResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(DuplicateOverviewResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<DuplicateOverviewResponse[]>(null as any);
  }

  /**
   * Get breakup of requests by billable customers.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getBookingsBreakup(
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<BreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Requests?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBookingsBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBookingsBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BreakupResponse[]
            >;
        })
      );
  }

  protected processGetBookingsBreakup(
    response: HttpResponseBase
  ): Observable<BreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BreakupResponse[]>(null as any);
  }

  /**
   * Get breakup of open bookings for a user by age (in days).
   * @param comp (optional) The company's identifier.
   * @return Successful operation
   */
  getOpenRequestsBreakup(
    comp: number | undefined
  ): Observable<OpenRequestsBreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Open?";
    if (comp === null) throw new Error("The parameter 'comp' cannot be null.");
    else if (comp !== undefined)
      url_ += "comp=" + encodeURIComponent("" + comp) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOpenRequestsBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOpenRequestsBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                OpenRequestsBreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              OpenRequestsBreakupResponse[]
            >;
        })
      );
  }

  protected processGetOpenRequestsBreakup(
    response: HttpResponseBase
  ): Observable<OpenRequestsBreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(OpenRequestsBreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<OpenRequestsBreakupResponse[]>(null as any);
  }

  /**
   * Get breakup of active practices by billable customers.
   * @return Successful operation
   */
  getPracticesBreakup(): Observable<BreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Practices";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPracticesBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPracticesBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BreakupResponse[]
            >;
        })
      );
  }

  protected processGetPracticesBreakup(
    response: HttpResponseBase
  ): Observable<BreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BreakupResponse[]>(null as any);
  }

  /**
   * Get breakup of active doctors by billable customers.
   * @return Successful operation
   */
  getDoctorsBreakup(): Observable<BreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Doctors";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDoctorsBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDoctorsBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BreakupResponse[]
            >;
        })
      );
  }

  protected processGetDoctorsBreakup(
    response: HttpResponseBase
  ): Observable<BreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BreakupResponse[]>(null as any);
  }

  /**
   * Get breakup of revenue by billable customers.
   * @param month (optional) The month to use.
   * @return Successful operation
   */
  getRevenueBreakup(
    month: string | null | undefined
  ): Observable<BreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Revenue?";
    if (month !== undefined && month !== null)
      url_ += "month=" + encodeURIComponent("" + month) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRevenueBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRevenueBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BreakupResponse[]
            >;
        })
      );
  }

  protected processGetRevenueBreakup(
    response: HttpResponseBase
  ): Observable<BreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BreakupResponse[]>(null as any);
  }

  /**
   * Get breakup of duplicate bookings.
   * @param fromDate (optional) Start of date/time range.
   * @param toDate (optional) End of date/time range.
   * @return Successful operation
   */
  getDuplicatesBreakup(
    fromDate: Date | undefined,
    toDate: Date | undefined
  ): Observable<BreakupResponse[]> {
    let url_ = this.baseUrl + "/api/Support/Breakup/Duplicates?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "fromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "toDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDuplicatesBreakup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDuplicatesBreakup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                BreakupResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              BreakupResponse[]
            >;
        })
      );
  }

  protected processGetDuplicatesBreakup(
    response: HttpResponseBase
  ): Observable<BreakupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(BreakupResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<BreakupResponse[]>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class TokenClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Authenticate user and provide an access token for subsequent calls.
   * @param userLoginDto User login details.
   * @return Successfully authenticated the user
   */
  
  authenticate(userLoginDto: UserLoginRequest): Observable<TokenResponse> {
    let url_ = this.baseUrl + "/api/Token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(userLoginDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TokenResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TokenResponse>;
        })
      );
  }

  protected processAuthenticate(
    response: HttpResponseBase
  ): Observable<TokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TokenResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TokenResponse>(null as any);
  }

  /**
   * Revoke a refresh token.
   * @param token Token to be revoked.
   * @return Successfully revoked a token
   */
  revokeCurrentToken(token: string): Observable<void> {
    let url_ = this.baseUrl + "/api/Token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(token);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevokeCurrentToken(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevokeCurrentToken(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRevokeCurrentToken(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gives access token based on refresh token.
   * @param refreshToken Refresh token.
   * @return Successfully gives another token
   */
  refreshToken(
    refreshToken: RefreshAuthenticationRequest
  ): Observable<TokenResponse> {
    let url_ = this.baseUrl + "/api/Token/Refresh";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(refreshToken);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRefreshToken(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRefreshToken(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TokenResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TokenResponse>;
        })
      );
  }

  protected processRefreshToken(
    response: HttpResponseBase
  ): Observable<TokenResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TokenResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Given token is not attached user",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Refresh token has been removed",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TokenResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class UserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get your details.
   * @return Successful operation
   */
  get(): Observable<UserResponse> {
    let url_ = this.baseUrl + "/api/User";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponse>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<UserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The user account was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponse>(null as any);
  }

  /**
   * Change your password.
   * @param passwordChange Old and new passwords.
   * @return Successful operation
   */
  changePassword(passwordChange: UserChangePasswordRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/User/Password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(passwordChange);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processChangePassword(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The user account was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Get your settings.
   * @return Successful operation
   */
  getSettings(): Observable<SettingResponse[]> {
    let url_ = this.baseUrl + "/api/User/Setting";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSettings(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                SettingResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              SettingResponse[]
            >;
        })
      );
  }

  protected processGetSettings(
    response: HttpResponseBase
  ): Observable<SettingResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(SettingResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<SettingResponse[]>(null as any);
  }

  /**
   * Update one of your settings.
   * @param id The setting's identifier.
   * @param val The settings's new value.
   * @return Successful operation
   */
  updateSetting(id: number, val: string): Observable<SettingResponse> {
    let url_ = this.baseUrl + "/api/User/setting/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(val);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSetting(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSetting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettingResponse>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<SettingResponse>;
        })
      );
  }

  protected processUpdateSetting(
    response: HttpResponseBase
  ): Observable<SettingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SettingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified setting was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SettingResponse>(null as any);
  }
}

@Injectable({
  providedIn: "root",
})
export class UsersClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://localhost:44378";
  }

  /**
   * Get a user's locations.
   * @param id The user's identifier.
   * @return Successful operation
   */
  getUserLocations(id: number): Observable<UserLocationResponse[]> {
    let url_ = this.baseUrl + "/api/Users/User/{id}/Location";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserLocations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserLocations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserLocationResponse[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserLocationResponse[]
            >;
        })
      );
  }

  protected processGetUserLocations(
    response: HttpResponseBase
  ): Observable<UserLocationResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserLocationResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserLocationResponse[]>(null as any);
  }

  /**
   * Get users for this user's company.
   * @param page (optional) Start page.
   * @param amount (optional) Amount of records to return.
   * @return Successful operation
   */
  getUsers(
    page: number | undefined,
    amount: number | undefined
  ): Observable<UserResponseSupport[]> {
    let url_ = this.baseUrl + "/api/Users?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (amount === null)
      throw new Error("The parameter 'amount' cannot be null.");
    else if (amount !== undefined)
      url_ += "amount=" + encodeURIComponent("" + amount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                UserResponseSupport[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              UserResponseSupport[]
            >;
        })
      );
  }

  protected processGetUsers(
    response: HttpResponseBase
  ): Observable<UserResponseSupport[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(UserResponseSupport.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<UserResponseSupport[]>(null as any);
  }

  /**
   * Create a new user.
   * @param usr The new user's details.
   * @return Successfully created a new user
   */
  createUser(usr: UserRequest): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(usr);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUser(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processCreateUser(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified company or role was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified email address is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Get user's details.
   * @param id The user identifier.
   * @return Successful operation
   */
  getUserDetails(id: number): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserDetails(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processGetUserDetails(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Request a password reset for a specific user.
   * @param email The user's email address.
   * @return Successful operation
   */
  sendResetPassword(email: string): Observable<void> {
    let url_ = this.baseUrl + "/api/Users/password/request-reset";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(email);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendResetPassword(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Cannot find email in database",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates a user.
   * @param userId User's Id
   * @param usr The user's details.
   * @return Successfully updated a user
   */
  updateUser(
    userId: number,
    usr: UserUpdateRequest
  ): Observable<UserResponseSupport> {
    let url_ = this.baseUrl + "/api/Users/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(usr);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUser(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserResponseSupport>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserResponseSupport>;
        })
      );
  }

  protected processUpdateUser(
    response: HttpResponseBase
  ): Observable<UserResponseSupport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponseSupport.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Invalid or missing parameters",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified user was not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "The specified email address is already in use",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserResponseSupport>(null as any);
  }

  /**
   * Resets the user's email.
   * @return Successful operation
   */
  resetPassword(resetDto: PasswordResetRequest): Observable<void> {
    let url_ = this.baseUrl + "/api/Users/password/reset";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(resetDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Password does not conform to rules",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Cannot find email in database",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  extensions?: { [key: string]: any } | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
      if (_data["extensions"]) {
        this.extensions = {} as any;
        for (let key in _data["extensions"]) {
          if (_data["extensions"].hasOwnProperty(key))
            (<any>this.extensions)![key] = _data["extensions"][key];
        }
      }
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    if (this.extensions) {
      data["extensions"] = {};
      for (let key in this.extensions) {
        if (this.extensions.hasOwnProperty(key))
          (<any>data["extensions"])[key] = this.extensions[key];
      }
    }
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  extensions?: { [key: string]: any } | undefined;
}

export class AlertRequest implements IAlertRequest {
  title?: string | undefined;
  content?: string | undefined;

  constructor(data?: IAlertRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.content = _data["content"];
    }
  }

  static fromJS(data: any): AlertRequest {
    data = typeof data === "object" ? data : {};
    let result = new AlertRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["content"] = this.content;
    return data;
  }
}

export interface IAlertRequest {
  title?: string | undefined;
  content?: string | undefined;
}

export class AttachmentResponse implements IAttachmentResponse {
  attachmentKey!: number;
  thumbnail?: string | undefined;
  thumbnailType?: string | undefined;

  constructor(data?: IAttachmentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.attachmentKey = _data["attachmentKey"];
      this.thumbnail = _data["thumbnail"];
      this.thumbnailType = _data["thumbnailType"];
    }
  }

  static fromJS(data: any): AttachmentResponse {
    data = typeof data === "object" ? data : {};
    let result = new AttachmentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["attachmentKey"] = this.attachmentKey;
    data["thumbnail"] = this.thumbnail;
    data["thumbnailType"] = this.thumbnailType;
    return data;
  }
}

export interface IAttachmentResponse {
  attachmentKey: number;
  thumbnail?: string | undefined;
  thumbnailType?: string | undefined;
}

export class AttachmentImageResponse implements IAttachmentImageResponse {
  attachment?: string | undefined;
  attachmentType?: string | undefined;

  constructor(data?: IAttachmentImageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.attachment = _data["attachment"];
      this.attachmentType = _data["attachmentType"];
    }
  }

  static fromJS(data: any): AttachmentImageResponse {
    data = typeof data === "object" ? data : {};
    let result = new AttachmentImageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["attachment"] = this.attachment;
    data["attachmentType"] = this.attachmentType;
    return data;
  }
}

export interface IAttachmentImageResponse {
  attachment?: string | undefined;
  attachmentType?: string | undefined;
}

export class AttachmentRequestAnonymous implements IAttachmentRequestAnonymous {
  sukToken?: string | undefined;
  attachment?: string | undefined;

  constructor(data?: IAttachmentRequestAnonymous) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sukToken = _data["sukToken"];
      this.attachment = _data["attachment"];
    }
  }

  static fromJS(data: any): AttachmentRequestAnonymous {
    data = typeof data === "object" ? data : {};
    let result = new AttachmentRequestAnonymous();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sukToken"] = this.sukToken;
    data["attachment"] = this.attachment;
    return data;
  }
}

export interface IAttachmentRequestAnonymous {
  sukToken?: string | undefined;
  attachment?: string | undefined;
}

export class CacheResponse implements ICacheResponse {
  cacheKey!: number;
  thumbnail?: string | undefined;
  thumbnailType?: string | undefined;

  constructor(data?: ICacheResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cacheKey = _data["cacheKey"];
      this.thumbnail = _data["thumbnail"];
      this.thumbnailType = _data["thumbnailType"];
    }
  }

  static fromJS(data: any): CacheResponse {
    data = typeof data === "object" ? data : {};
    let result = new CacheResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["cacheKey"] = this.cacheKey;
    data["thumbnail"] = this.thumbnail;
    data["thumbnailType"] = this.thumbnailType;
    return data;
  }
}

export interface ICacheResponse {
  cacheKey: number;
  thumbnail?: string | undefined;
  thumbnailType?: string | undefined;
}

export class BookingResponse implements IBookingResponse {
  bookingKey!: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  providerNo?: string | undefined;
  referringPractice?: string | undefined;
  source?: string | undefined;
  location?: string | undefined;
  notes?: string | undefined;
  reminderDate: Date|undefined;
  status?: string | undefined;
  lostReason?: string | undefined;
  lostReasonComment?: string | undefined;
  smsSent!: number;
  isUrgent!: boolean;
  noteAlert!: boolean;
  createdDate!: Date;
  lastUpdatedDate!: Date;
  attachmentCount!: number;
  referringSoftwareName?: string | undefined;
  referringSoftwareVersion?: string | undefined;

  constructor(data?: IBookingResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingKey = _data["bookingKey"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.address = _data["address"];
      this.medicareNo = _data["medicareNo"];
      this.preferredBooking = _data["preferredBooking"];
      this.scanType = _data["scanType"];
      this.referringDoctor = _data["referringDoctor"];
      this.providerNo = _data["providerNo"];
      this.referringPractice = _data["referringPractice"];
      this.source = _data["source"];
      this.location = _data["location"];
      this.notes = _data["notes"];
      this.reminderDate = _data["reminderDate"]
        ? new Date(_data["reminderDate"].toString())
        : <any>undefined;
      this.status = _data["status"];
      this.lostReason = _data["lostReason"];
      this.lostReasonComment = _data["lostReasonComment"];
      this.smsSent = _data["smsSent"];
      this.isUrgent = _data["isUrgent"];
      this.noteAlert = _data["noteAlert"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
      this.lastUpdatedDate = _data["lastUpdatedDate"]
        ? new Date(_data["lastUpdatedDate"].toString())
        : <any>undefined;
      this.attachmentCount = _data["attachmentCount"];
      this.referringSoftwareName = _data["referringSoftwareName"];
      this.referringSoftwareVersion = _data["referringSoftwareVersion"];
    }
  }

  static fromJS(data: any): BookingResponse {
    data = typeof data === "object" ? data : {};
    let result = new BookingResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingKey"] = this.bookingKey;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["address"] = this.address;
    data["medicareNo"] = this.medicareNo;
    data["preferredBooking"] = this.preferredBooking;
    data["scanType"] = this.scanType;
    data["referringDoctor"] = this.referringDoctor;
    data["providerNo"] = this.providerNo;
    data["referringPractice"] = this.referringPractice;
    data["source"] = this.source;
    data["location"] = this.location;
    data["notes"] = this.notes;
    data["reminderDate"] = this.reminderDate
      ? this.reminderDate.toISOString()
      : <any>undefined;
    data["status"] = this.status;
    data["lostReason"] = this.lostReason;
    data["lostReasonComment"] = this.lostReasonComment;
    data["smsSent"] = this.smsSent;
    data["isUrgent"] = this.isUrgent;
    data["noteAlert"] = this.noteAlert;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    data["lastUpdatedDate"] = this.lastUpdatedDate
      ? this.lastUpdatedDate.toISOString()
      : <any>undefined;
    data["attachmentCount"] = this.attachmentCount;
    data["referringSoftwareName"] = this.referringSoftwareName;
    data["referringSoftwareVersion"] = this.referringSoftwareVersion;
    return data;
  }
}

export interface IBookingResponse {
  bookingKey: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  providerNo?: string | undefined;
  referringPractice?: string | undefined;
  source?: string | undefined;
  location?: string | undefined;
  notes?: string | undefined;
  reminderDate?: Date | undefined;
  status?: string | undefined;
  lostReason?: string | undefined;
  lostReasonComment?: string | undefined;
  smsSent: number;
  isUrgent: boolean;
  noteAlert: boolean;
  createdDate: Date;
  lastUpdatedDate: Date;
  attachmentCount: number;
  referringSoftwareName?: string | undefined;
  referringSoftwareVersion?: string | undefined;
}

export class BookingRequest implements IBookingRequest {
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  providerNo?: string | undefined;
  referringPractice?: string | undefined;
  sourceId?: string | undefined;
  locationKey!: number;
  notes?: string | undefined;
  externalID?: string | undefined;
  externalData?: string | undefined;
  referringSoftwareName?: string | undefined;
  referringSoftwareVersion?: string | undefined;

  constructor(data?: IBookingRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.address = _data["address"];
      this.medicareNo = _data["medicareNo"];
      this.preferredBooking = _data["preferredBooking"];
      this.scanType = _data["scanType"];
      this.referringDoctor = _data["referringDoctor"];
      this.providerNo = _data["providerNo"];
      this.referringPractice = _data["referringPractice"];
      this.sourceId = _data["sourceId"];
      this.locationKey = _data["locationKey"];
      this.notes = _data["notes"];
      this.externalID = _data["externalID"];
      this.externalData = _data["externalData"];
      this.referringSoftwareName = _data["referringSoftwareName"];
      this.referringSoftwareVersion = _data["referringSoftwareVersion"];
    }
  }

  static fromJS(data: any): BookingRequest {
    data = typeof data === "object" ? data : {};
    let result = new BookingRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["address"] = this.address;
    data["medicareNo"] = this.medicareNo;
    data["preferredBooking"] = this.preferredBooking;
    data["scanType"] = this.scanType;
    data["referringDoctor"] = this.referringDoctor;
    data["providerNo"] = this.providerNo;
    data["referringPractice"] = this.referringPractice;
    data["sourceId"] = this.sourceId;
    data["locationKey"] = this.locationKey;
    data["notes"] = this.notes;
    data["externalID"] = this.externalID;
    data["externalData"] = this.externalData;
    data["referringSoftwareName"] = this.referringSoftwareName;
    data["referringSoftwareVersion"] = this.referringSoftwareVersion;
    return data;
  }
}

export interface IBookingRequest {
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  providerNo?: string | undefined;
  referringPractice?: string | undefined;
  sourceId?: string | undefined;
  locationKey: number;
  notes?: string | undefined;
  externalID?: string | undefined;
  externalData?: string | undefined;
  referringSoftwareName?: string | undefined;
  referringSoftwareVersion?: string | undefined;
}

export class BookingResponseAnonymous implements IBookingResponseAnonymous {
  bookingKey!: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  source?: string | undefined;
  location?: string | undefined;
  notes?: string | undefined;
  reminderDate?: Date | undefined;
  status?: string | undefined;
  createdDate!: Date;
  lastUpdatedDate!: Date;
  attachmentTokens?: string[] | undefined;

  constructor(data?: IBookingResponseAnonymous) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingKey = _data["bookingKey"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.address = _data["address"];
      this.medicareNo = _data["medicareNo"];
      this.preferredBooking = _data["preferredBooking"];
      this.scanType = _data["scanType"];
      this.referringDoctor = _data["referringDoctor"];
      this.source = _data["source"];
      this.location = _data["location"];
      this.notes = _data["notes"];
      this.reminderDate = _data["reminderDate"]
        ? new Date(_data["reminderDate"].toString())
        : <any>undefined;
      this.status = _data["status"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
      this.lastUpdatedDate = _data["lastUpdatedDate"]
        ? new Date(_data["lastUpdatedDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["attachmentTokens"])) {
        this.attachmentTokens = [] as any;
        for (let item of _data["attachmentTokens"])
          this.attachmentTokens!.push(item);
      }
    }
  }

  static fromJS(data: any): BookingResponseAnonymous {
    data = typeof data === "object" ? data : {};
    let result = new BookingResponseAnonymous();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingKey"] = this.bookingKey;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["address"] = this.address;
    data["medicareNo"] = this.medicareNo;
    data["preferredBooking"] = this.preferredBooking;
    data["scanType"] = this.scanType;
    data["referringDoctor"] = this.referringDoctor;
    data["source"] = this.source;
    data["location"] = this.location;
    data["notes"] = this.notes;
    data["reminderDate"] = this.reminderDate
      ? this.reminderDate.toISOString()
      : <any>undefined;
    data["status"] = this.status;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    data["lastUpdatedDate"] = this.lastUpdatedDate
      ? this.lastUpdatedDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.attachmentTokens)) {
      data["attachmentTokens"] = [];
      for (let item of this.attachmentTokens)
        data["attachmentTokens"].push(item);
    }
    return data;
  }
}

export interface IBookingResponseAnonymous {
  bookingKey: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  source?: string | undefined;
  location?: string | undefined;
  notes?: string | undefined;
  reminderDate?: Date | undefined;
  status?: string | undefined;
  createdDate: Date;
  lastUpdatedDate: Date;
  attachmentTokens?: string[] | undefined;
}

export class BookingRequestAnonymous implements IBookingRequestAnonymous {
  captchaToken?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  sourceId?: string | undefined;
  locationKey!: number;
  notes?: string | undefined;
  requiredAttachmentTokens!: number;

  constructor(data?: IBookingRequestAnonymous) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.captchaToken = _data["captchaToken"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.address = _data["address"];
      this.medicareNo = _data["medicareNo"];
      this.preferredBooking = _data["preferredBooking"];
      this.scanType = _data["scanType"];
      this.referringDoctor = _data["referringDoctor"];
      this.sourceId = _data["sourceId"];
      this.locationKey = _data["locationKey"];
      this.notes = _data["notes"];
      this.requiredAttachmentTokens = _data["requiredAttachmentTokens"];
    }
  }

  static fromJS(data: any): BookingRequestAnonymous {
    data = typeof data === "object" ? data : {};
    let result = new BookingRequestAnonymous();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["captchaToken"] = this.captchaToken;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["address"] = this.address;
    data["medicareNo"] = this.medicareNo;
    data["preferredBooking"] = this.preferredBooking;
    data["scanType"] = this.scanType;
    data["referringDoctor"] = this.referringDoctor;
    data["sourceId"] = this.sourceId;
    data["locationKey"] = this.locationKey;
    data["notes"] = this.notes;
    data["requiredAttachmentTokens"] = this.requiredAttachmentTokens;
    return data;
  }
}

export interface IBookingRequestAnonymous {
  captchaToken?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  referringDoctor?: string | undefined;
  sourceId?: string | undefined;
  locationKey: number;
  notes?: string | undefined;
  requiredAttachmentTokens: number;
}

export class BookingUpdateRequest implements IBookingUpdateRequest {
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  locationKey!: number;
  reminderDate?: Date | undefined;

  constructor(data?: IBookingUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.address = _data["address"];
      this.medicareNo = _data["medicareNo"];
      this.preferredBooking = _data["preferredBooking"];
      this.scanType = _data["scanType"];
      this.locationKey = _data["locationKey"];
      this.reminderDate = _data["reminderDate"]
        ? new Date(_data["reminderDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): BookingUpdateRequest {
    data = typeof data === "object" ? data : {};
    let result = new BookingUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["address"] = this.address;
    data["medicareNo"] = this.medicareNo;
    data["preferredBooking"] = this.preferredBooking;
    data["scanType"] = this.scanType;
    data["locationKey"] = this.locationKey;
    data["reminderDate"] = this.reminderDate
      ? this.reminderDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IBookingUpdateRequest {
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  address?: string | undefined;
  medicareNo?: string | undefined;
  preferredBooking?: string | undefined;
  scanType?: string | undefined;
  locationKey: number;
  reminderDate?: Date | undefined;
}

export class LogResponse implements ILogResponse {
  logType?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  comments?: string | undefined;
  createdDate!: Date;

  constructor(data?: ILogResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logType = _data["logType"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.comments = _data["comments"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): LogResponse {
    data = typeof data === "object" ? data : {};
    let result = new LogResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logType"] = this.logType;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["comments"] = this.comments;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ILogResponse {
  logType?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  comments?: string | undefined;
  createdDate: Date;
}
export class ParkedReasonRequest implements IParkedReasonRequest {
  parkReasonKey!: number;
  comments?: string | undefined;

  constructor(data?: IParkedReasonRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parkReasonKey = _data["parkReasonKey"];
      this.comments = _data["comments"];
    }
  }

  static fromJS(data: any): ParkedReasonRequest {
    data = typeof data === "object" ? data : {};
    let result = new ParkedReasonRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["parkReasonKey"] = this.parkReasonKey;
    data["comments"] = this.comments;
    return data;
  }
}

export interface IParkedReasonRequest {
  parkReasonKey: number;
  comments?: string | undefined;
}

export class LostReasonRequest implements ILostReasonRequest {
  lostReasonKey!: number;
  comments?: string | undefined;

  constructor(data?: ILostReasonRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lostReasonKey = _data["lostReasonKey"];
      this.comments = _data["comments"];
    }
  }

  static fromJS(data: any): LostReasonRequest {
    data = typeof data === "object" ? data : {};
    let result = new LostReasonRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["lostReasonKey"] = this.lostReasonKey;
    data["comments"] = this.comments;
    return data;
  }
}

export interface ILostReasonRequest {
  lostReasonKey: number;
  comments?: string | undefined;
}

export class SMSRequest implements ISMSRequest {
  bookingKey!: number;
  from?: string | undefined;
  message?: string | undefined;

  constructor(data?: ISMSRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingKey = _data["bookingKey"];
      this.from = _data["from"];
      this.message = _data["message"];
    }
  }

  static fromJS(data: any): SMSRequest {
    data = typeof data === "object" ? data : {};
    let result = new SMSRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingKey"] = this.bookingKey;
    data["from"] = this.from;
    data["message"] = this.message;
    return data;
  }
}

export interface ISMSRequest {
  bookingKey: number;
  from?: string | undefined;
  message?: string | undefined;
}

export class CompanyResponseSupport implements ICompanyResponseSupport {
  companyKey!: number;
  companyID?: string | undefined;
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;
  active!: boolean;
  analyticsApiKey?: string | undefined;
  billingName?: string | undefined;
  billingAddress1?: string | undefined;
  billingAddress2?: string | undefined;
  billingCode?: string | undefined;
  accManName?: string | undefined;
  accManEmail?: string | undefined;
  accManPhone?: string | undefined;
  purchaseOrder?: string | undefined;
  chargeRate?: number | undefined;
  billable!: boolean;

  constructor(data?: ICompanyResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyKey = _data["companyKey"];
      this.companyID = _data["companyID"];
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
      this.logoType = _data["logoType"];
      this.active = _data["active"];
      this.analyticsApiKey = _data["analyticsApiKey"];
      this.billingName = _data["billingName"];
      this.billingAddress1 = _data["billingAddress1"];
      this.billingAddress2 = _data["billingAddress2"];
      this.billingCode = _data["billingCode"];
      this.accManName = _data["accManName"];
      this.accManEmail = _data["accManEmail"];
      this.accManPhone = _data["accManPhone"];
      this.purchaseOrder = _data["purchaseOrder"];
      this.chargeRate = _data["chargeRate"];
      this.billable = _data["billable"];
    }
  }

  static fromJS(data: any): CompanyResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new CompanyResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyKey"] = this.companyKey;
    data["companyID"] = this.companyID;
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    data["logoType"] = this.logoType;
    data["active"] = this.active;
    data["analyticsApiKey"] = this.analyticsApiKey;
    data["billingName"] = this.billingName;
    data["billingAddress1"] = this.billingAddress1;
    data["billingAddress2"] = this.billingAddress2;
    data["billingCode"] = this.billingCode;
    data["accManName"] = this.accManName;
    data["accManEmail"] = this.accManEmail;
    data["accManPhone"] = this.accManPhone;
    data["purchaseOrder"] = this.purchaseOrder;
    data["chargeRate"] = this.chargeRate;
    data["billable"] = this.billable;
    return data;
  }
}

export interface ICompanyResponseSupport {
  companyKey: number;
  companyID?: string | undefined;
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;
  active: boolean;
  analyticsApiKey?: string | undefined;
  billingName?: string | undefined;
  billingAddress1?: string | undefined;
  billingAddress2?: string | undefined;
  billingCode?: string | undefined;
  accManName?: string | undefined;
  accManEmail?: string | undefined;
  accManPhone?: string | undefined;
  purchaseOrder?: string | undefined;
  chargeRate?: number | undefined;
  billable: boolean;
}

export class CompanyResponse implements ICompanyResponse {
  companyKey!: number;
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;

  constructor(data?: ICompanyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyKey = _data["companyKey"];
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
      this.logoType = _data["logoType"];
    }
  }

  static fromJS(data: any): CompanyResponse {
    data = typeof data === "object" ? data : {};
    let result = new CompanyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyKey"] = this.companyKey;
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    data["logoType"] = this.logoType;
    return data;
  }
}

export interface ICompanyResponse {
  companyKey: number;
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;
}

export class CompanyUpdateRequest implements ICompanyUpdateRequest {
  companyName?: string | undefined;
  logo?: string | undefined;
  active?: boolean | undefined;

  constructor(data?: ICompanyUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
      this.active = _data["active"];
    }
  }

  static fromJS(data: any): CompanyUpdateRequest {
    data = typeof data === "object" ? data : {};
    let result = new CompanyUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    data["active"] = this.active;
    return data;
  }
}

export interface ICompanyUpdateRequest {
  companyName?: string | undefined;
  logo?: string | undefined;
  active?: boolean | undefined;
}

export class CompanyResponseAnonymous implements ICompanyResponseAnonymous {
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;
  locations?: Location[] | undefined;

  constructor(data?: ICompanyResponseAnonymous) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
      this.logoType = _data["logoType"];
      if (Array.isArray(_data["locations"])) {
        this.locations = [] as any;
        for (let item of _data["locations"])
          this.locations!.push(Location.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompanyResponseAnonymous {
    data = typeof data === "object" ? data : {};
    let result = new CompanyResponseAnonymous();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    data["logoType"] = this.logoType;
    if (Array.isArray(this.locations)) {
      data["locations"] = [];
      for (let item of this.locations) data["locations"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICompanyResponseAnonymous {
  companyName?: string | undefined;
  logo?: string | undefined;
  logoType?: string | undefined;
  locations?: Location[] | undefined;
}

export class Location implements ILocation {
  locationKey!: number;
  locationName?: string | undefined;

  constructor(data?: ILocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.locationName = _data["locationName"];
    }
  }

  static fromJS(data: any): Location {
    data = typeof data === "object" ? data : {};
    let result = new Location();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["locationName"] = this.locationName;
    return data;
  }
}

export interface ILocation {
  locationKey: number;
  locationName?: string | undefined;
}

export class ReferringPracticeResponse implements IReferringPracticeResponse {
  referringPractice?: string | undefined;
  lastRequestDate!: Date;
  lastLocationKey!: number;
  lastLocationName?: string | undefined;

  constructor(data?: IReferringPracticeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referringPractice = _data["referringPractice"];
      this.lastRequestDate = _data["lastRequestDate"]
        ? new Date(_data["lastRequestDate"].toString())
        : <any>undefined;
      this.lastLocationKey = _data["lastLocationKey"];
      this.lastLocationName = _data["lastLocationName"];
    }
  }

  static fromJS(data: any): ReferringPracticeResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPracticeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["referringPractice"] = this.referringPractice;
    data["lastRequestDate"] = this.lastRequestDate
      ? this.lastRequestDate.toISOString()
      : <any>undefined;
    data["lastLocationKey"] = this.lastLocationKey;
    data["lastLocationName"] = this.lastLocationName;
    return data;
  }
}

export interface IReferringPracticeResponse {
  referringPractice?: string | undefined;
  lastRequestDate: Date;
  lastLocationKey: number;
  lastLocationName?: string | undefined;
}

export class SettingResponse implements ISettingResponse {
  settingKey!: number;
  settingName?: string | undefined;
  settingValue?: string | undefined;

  constructor(data?: ISettingResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.settingKey = _data["settingKey"];
      this.settingName = _data["settingName"];
      this.settingValue = _data["settingValue"];
    }
  }

  static fromJS(data: any): SettingResponse {
    data = typeof data === "object" ? data : {};
    let result = new SettingResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["settingKey"] = this.settingKey;
    data["settingName"] = this.settingName;
    data["settingValue"] = this.settingValue;
    return data;
  }
}

export interface ISettingResponse {
  settingKey: number;
  settingName?: string | undefined;
  settingValue?: string | undefined;
}

export class GraphDataResponse implements IGraphDataResponse {
  graphTitle?: string | undefined;
  subtitle?: string | undefined;
  graphType?: string | undefined;
  data?: GenericGraphData[] | undefined;

  constructor(data?: IGraphDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.graphTitle = _data["graphTitle"];
      this.subtitle = _data["subtitle"];
      this.graphType = _data["graphType"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(GenericGraphData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GraphDataResponse {
    data = typeof data === "object" ? data : {};
    let result = new GraphDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["graphTitle"] = this.graphTitle;
    data["subtitle"] = this.subtitle;
    data["graphType"] = this.graphType;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGraphDataResponse {
  graphTitle?: string | undefined;
  subtitle?: string | undefined;
  graphType?: string | undefined;
  data?: GenericGraphData[] | undefined;
}

export class GenericGraphData implements IGenericGraphData {
  name?: string | undefined;
  value!: number;

  constructor(data?: IGenericGraphData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): GenericGraphData {
    data = typeof data === "object" ? data : {};
    let result = new GenericGraphData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface IGenericGraphData {
  name?: string | undefined;
  value: number;
}

export class LocationResponse implements ILocationResponse {
  locationKey!: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  defaultLocation!: boolean;
  address?: string | undefined;
  phone?: string | undefined;
  activeLocation!: boolean;
  groupName?: string | undefined;
  groupSmsName?: string | undefined;
  groupSmsID?: string | undefined;
  groupPhone?: string | undefined;

  constructor(data?: ILocationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.companyName = _data["companyName"];
      this.locationName = _data["locationName"];
      this.locationNameShort = _data["locationNameShort"];
      this.defaultLocation = _data["defaultLocation"];
      this.address = _data["address"];
      this.phone = _data["phone"];
      this.activeLocation = _data["activeLocation"];
      this.groupName = _data["groupName"];
      this.groupSmsName = _data["groupSmsName"];
      this.groupSmsID = _data["groupSmsID"];
      this.groupPhone = _data["groupPhone"];
    }
  }

  static fromJS(data: any): LocationResponse {
    data = typeof data === "object" ? data : {};
    let result = new LocationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["companyName"] = this.companyName;
    data["locationName"] = this.locationName;
    data["locationNameShort"] = this.locationNameShort;
    data["defaultLocation"] = this.defaultLocation;
    data["address"] = this.address;
    data["phone"] = this.phone;
    data["activeLocation"] = this.activeLocation;
    data["groupName"] = this.groupName;
    data["groupSmsName"] = this.groupSmsName;
    data["groupSmsID"] = this.groupSmsID;
    data["groupPhone"] = this.groupPhone;
    return data;
  }
}

export interface ILocationResponse {
  locationKey: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  defaultLocation: boolean;
  address?: string | undefined;
  phone?: string | undefined;
  activeLocation: boolean;
  groupName?: string | undefined;
  groupSmsName?: string | undefined;
  groupSmsID?: string | undefined;
  groupPhone?: string | undefined;
}

export class LocationRequest implements ILocationRequest {
  companyKey!: number;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;

  constructor(data?: ILocationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyKey = _data["companyKey"];
      this.locationName = _data["locationName"];
      this.locationNameShort = _data["locationNameShort"];
      this.address = _data["address"];
      this.phone = _data["phone"];
    }
  }

  static fromJS(data: any): LocationRequest {
    data = typeof data === "object" ? data : {};
    let result = new LocationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyKey"] = this.companyKey;
    data["locationName"] = this.locationName;
    data["locationNameShort"] = this.locationNameShort;
    data["address"] = this.address;
    data["phone"] = this.phone;
    return data;
  }
}

export interface ILocationRequest {
  companyKey: number;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;
}

export class LocationUpdateRequest implements ILocationUpdateRequest {
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;
  active?: boolean | undefined;

  constructor(data?: ILocationUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationName = _data["locationName"];
      this.locationNameShort = _data["locationNameShort"];
      this.address = _data["address"];
      this.phone = _data["phone"];
      this.active = _data["active"];
    }
  }

  static fromJS(data: any): LocationUpdateRequest {
    data = typeof data === "object" ? data : {};
    let result = new LocationUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationName"] = this.locationName;
    data["locationNameShort"] = this.locationNameShort;
    data["address"] = this.address;
    data["phone"] = this.phone;
    data["active"] = this.active;
    return data;
  }
}

export interface ILocationUpdateRequest {
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;
  active?: boolean | undefined;
}

export class UserLocationResponse implements IUserLocationResponse {
  locationKey!: number;
  locationName?: string | undefined;
  userKey?: number | undefined;
  default!: boolean;
  allocated!: boolean;

  constructor(data?: IUserLocationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.locationName = _data["locationName"];
      this.userKey = _data["userKey"];
      this.default = _data["default"];
      this.allocated = _data["allocated"];
    }
  }

  static fromJS(data: any): UserLocationResponse {
    data = typeof data === "object" ? data : {};
    let result = new UserLocationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["locationName"] = this.locationName;
    data["userKey"] = this.userKey;
    data["default"] = this.default;
    data["allocated"] = this.allocated;
    return data;
  }
}

export interface IUserLocationResponse {
  locationKey: number;
  locationName?: string | undefined;
  userKey?: number | undefined;
  default: boolean;
  allocated: boolean;
}

export class LocationAliasResponse implements ILocationAliasResponse {
  locationKey!: number;
  companyKey!: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  locationPhone?: string | undefined;
  activeLocation!: boolean;
  aliasGroupID?: string | undefined;
  aliasGroupName?: string | undefined;
  aliasLocationName?: string | undefined;
  smartRouting!: boolean;

  constructor(data?: ILocationAliasResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.companyKey = _data["companyKey"];
      this.companyName = _data["companyName"];
      this.locationName = _data["locationName"];
      this.locationPhone = _data["locationPhone"];
      this.activeLocation = _data["activeLocation"];
      this.aliasGroupID = _data["aliasGroupID"];
      this.aliasGroupName = _data["aliasGroupName"];
      this.aliasLocationName = _data["aliasLocationName"];
      this.smartRouting = _data["smartRouting"];
    }
  }

  static fromJS(data: any): LocationAliasResponse {
    data = typeof data === "object" ? data : {};
    let result = new LocationAliasResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["companyKey"] = this.companyKey;
    data["companyName"] = this.companyName;
    data["locationName"] = this.locationName;
    data["locationPhone"] = this.locationPhone;
    data["activeLocation"] = this.activeLocation;
    data["aliasGroupID"] = this.aliasGroupID;
    data["aliasGroupName"] = this.aliasGroupName;
    data["aliasLocationName"] = this.aliasLocationName;
    data["smartRouting"] = this.smartRouting;
    return data;
  }
}

export interface ILocationAliasResponse {
  locationKey: number;
  companyKey: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  locationPhone?: string | undefined;
  activeLocation: boolean;
  aliasGroupID?: string | undefined;
  aliasGroupName?: string | undefined;
  aliasLocationName?: string | undefined;
  smartRouting: boolean;
}

export class KeyValuePairOfStringAndString
  implements IKeyValuePairOfStringAndString
{
  key!: string;
  value!: string;

  constructor(data?: IKeyValuePairOfStringAndString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): KeyValuePairOfStringAndString {
    data = typeof data === "object" ? data : {};
    let result = new KeyValuePairOfStringAndString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["value"] = this.value;
    return data;
  }
}

export interface IKeyValuePairOfStringAndString {
  key: string;
  value: string;
}

export class LostReasonResponse implements ILostReasonResponse {
  reasonKey!: number;
  reasonName?: string | undefined;

  constructor(data?: ILostReasonResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reasonKey = _data["reasonKey"];
      this.reasonName = _data["reasonName"];
    }
  }

  static fromJS(data: any): LostReasonResponse {
    data = typeof data === "object" ? data : {};
    let result = new LostReasonResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reasonKey"] = this.reasonKey;
    data["reasonName"] = this.reasonName;
    return data;
  }
}

export interface ILostReasonResponse {
  reasonKey: number;
  reasonName?: string | undefined;
}

export class ReferringPracticeUageResponse
  implements IReferringPracticeUageResponse
{
  referringPractice?: string | undefined;
  usage?: ReferringPracticeUsage[] | undefined;

  constructor(data?: IReferringPracticeUageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referringPractice = _data["referringPractice"];
      if (Array.isArray(_data["usage"])) {
        this.usage = [] as any;
        for (let item of _data["usage"])
          this.usage!.push(ReferringPracticeUsage.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReferringPracticeUageResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPracticeUageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["referringPractice"] = this.referringPractice;
    if (Array.isArray(this.usage)) {
      data["usage"] = [];
      for (let item of this.usage) data["usage"].push(item.toJSON());
    }
    return data;
  }
}

export interface IReferringPracticeUageResponse {
  referringPractice?: string | undefined;
  usage?: ReferringPracticeUsage[] | undefined;
}

export class ReferringPracticeUsage implements IReferringPracticeUsage {
  customerName?: string | undefined;
  locationName?: string | undefined;
  count!: number;

  constructor(data?: IReferringPracticeUsage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerName = _data["customerName"];
      this.locationName = _data["locationName"];
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): ReferringPracticeUsage {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPracticeUsage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerName"] = this.customerName;
    data["locationName"] = this.locationName;
    data["count"] = this.count;
    return data;
  }
}

export interface IReferringPracticeUsage {
  customerName?: string | undefined;
  locationName?: string | undefined;
  count: number;
}

export class ReferringPracticeLookupResponse
  implements IReferringPracticeLookupResponse
{
  referringPracticeCode?: string | undefined;
  referringPracticeName?: string | undefined;

  constructor(data?: IReferringPracticeLookupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referringPracticeCode = _data["referringPracticeCode"];
      this.referringPracticeName = _data["referringPracticeName"];
    }
  }

  static fromJS(data: any): ReferringPracticeLookupResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPracticeLookupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["referringPracticeCode"] = this.referringPracticeCode;
    data["referringPracticeName"] = this.referringPracticeName;
    return data;
  }
}

export interface IReferringPracticeLookupResponse {
  referringPracticeCode?: string | undefined;
  referringPracticeName?: string | undefined;
}

export class ReminderResponse implements IReminderResponse {
  patientName?: string | undefined;
  date!: Date;
  bookingKey!: number;
  locationKey!: number;
  urgent!: boolean;
  smsStatus!: boolean;

  constructor(data?: IReminderResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.patientName = _data["patientName"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.bookingKey = _data["bookingKey"];
      this.locationKey = _data["locationKey"];
      this.urgent = _data["urgent"];
      this.smsStatus = _data["smsStatus"];
    }
  }

  static fromJS(data: any): ReminderResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReminderResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["patientName"] = this.patientName;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["bookingKey"] = this.bookingKey;
    data["locationKey"] = this.locationKey;
    data["urgent"] = this.urgent;
    data["smsStatus"] = this.smsStatus;
    return data;
  }
}

export interface IReminderResponse {
  patientName?: string | undefined;
  date: Date;
  bookingKey: number;
  locationKey: number;
  urgent: boolean;
  smsStatus: boolean;
}

export class ReportResponse implements IReportResponse {
  reportKey!: number;
  reportName?: string | undefined;
  reportDescription?: string | undefined;
  criteriaType?: string | undefined;
  printOrientation?: string | undefined;

  constructor(data?: IReportResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportKey = _data["reportKey"];
      this.reportName = _data["reportName"];
      this.reportDescription = _data["reportDescription"];
      this.criteriaType = _data["criteriaType"];
      this.printOrientation = _data["printOrientation"];
    }
  }

  static fromJS(data: any): ReportResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReportResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reportKey"] = this.reportKey;
    data["reportName"] = this.reportName;
    data["reportDescription"] = this.reportDescription;
    data["criteriaType"] = this.criteriaType;
    data["printOrientation"] = this.printOrientation;
    return data;
  }
}

export interface IReportResponse {
  reportKey: number;
  reportName?: string | undefined;
  reportDescription?: string | undefined;
  criteriaType?: string | undefined;
  printOrientation?: string | undefined;
}

export class ReportDataResponse implements IReportDataResponse {
  headingRow?: ColumnDetails[] | undefined;
  detailRows?: string[][] | undefined;
  totalRow?: string[] | undefined;

  constructor(data?: IReportDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["headingRow"])) {
        this.headingRow = [] as any;
        for (let item of _data["headingRow"])
          this.headingRow!.push(ColumnDetails.fromJS(item));
      }
      if (Array.isArray(_data["detailRows"])) {
        this.detailRows = [] as any;
        for (let item of _data["detailRows"]) this.detailRows!.push(item);
      }
      if (Array.isArray(_data["totalRow"])) {
        this.totalRow = [] as any;
        for (let item of _data["totalRow"]) this.totalRow!.push(item);
      }
    }
  }

  static fromJS(data: any): ReportDataResponse {
    data = typeof data === "object" ? data : {};
    let result = new ReportDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.headingRow)) {
      data["headingRow"] = [];
      for (let item of this.headingRow) data["headingRow"].push(item.toJSON());
    }
    if (Array.isArray(this.detailRows)) {
      data["detailRows"] = [];
      for (let item of this.detailRows) data["detailRows"].push(item);
    }
    if (Array.isArray(this.totalRow)) {
      data["totalRow"] = [];
      for (let item of this.totalRow) data["totalRow"].push(item);
    }
    return data;
  }
}

export interface IReportDataResponse {
  headingRow?: ColumnDetails[] | undefined;
  detailRows?: string[][] | undefined;
  totalRow?: string[] | undefined;
}

export class ColumnDetails implements IColumnDetails {
  name?: string | undefined;
  size!: number;

  constructor(data?: IColumnDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.size = _data["size"];
    }
  }

  static fromJS(data: any): ColumnDetails {
    data = typeof data === "object" ? data : {};
    let result = new ColumnDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["size"] = this.size;
    return data;
  }
}

export interface IColumnDetails {
  name?: string | undefined;
  size: number;
}

export class RoleResponse implements IRoleResponse {
  key!: number;
  name?: string | undefined;
  description?: string | undefined;

  constructor(data?: IRoleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): RoleResponse {
    data = typeof data === "object" ? data : {};
    let result = new RoleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IRoleResponse {
  key: number;
  name?: string | undefined;
  description?: string | undefined;
}

export class ServiceResponse implements IServiceResponse {
  serviceKey!: number;
  serviceName?: string | undefined;
  lastUpdatedDate!: Date;
  lastActivityDate?: Date | undefined;
  errorCount!: number;
  commandInput?: string | undefined;

  constructor(data?: IServiceResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceKey = _data["serviceKey"];
      this.serviceName = _data["serviceName"];
      this.lastUpdatedDate = _data["lastUpdatedDate"]
        ? new Date(_data["lastUpdatedDate"].toString())
        : <any>undefined;
      this.lastActivityDate = _data["lastActivityDate"]
        ? new Date(_data["lastActivityDate"].toString())
        : <any>undefined;
      this.errorCount = _data["errorCount"];
      this.commandInput = _data["commandInput"];
    }
  }

  static fromJS(data: any): ServiceResponse {
    data = typeof data === "object" ? data : {};
    let result = new ServiceResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceKey"] = this.serviceKey;
    data["serviceName"] = this.serviceName;
    data["lastUpdatedDate"] = this.lastUpdatedDate
      ? this.lastUpdatedDate.toISOString()
      : <any>undefined;
    data["lastActivityDate"] = this.lastActivityDate
      ? this.lastActivityDate.toISOString()
      : <any>undefined;
    data["errorCount"] = this.errorCount;
    data["commandInput"] = this.commandInput;
    return data;
  }
}

export interface IServiceResponse {
  serviceKey: number;
  serviceName?: string | undefined;
  lastUpdatedDate: Date;
  lastActivityDate?: Date | undefined;
  errorCount: number;
  commandInput?: string | undefined;
}

export class ServiceRequest implements IServiceRequest {
  errorCount!: number;
  commandInput?: string | undefined;
  hadActivity!: boolean;

  constructor(data?: IServiceRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.errorCount = _data["errorCount"];
      this.commandInput = _data["commandInput"];
      this.hadActivity = _data["hadActivity"];
    }
  }

  static fromJS(data: any): ServiceRequest {
    data = typeof data === "object" ? data : {};
    let result = new ServiceRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["errorCount"] = this.errorCount;
    data["commandInput"] = this.commandInput;
    data["hadActivity"] = this.hadActivity;
    return data;
  }
}

export interface IServiceRequest {
  errorCount: number;
  commandInput?: string | undefined;
  hadActivity: boolean;
}

export class BookingSearchResponseSupport
  implements IBookingSearchResponseSupport
{
  bookingKey!: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  scanType?: string | undefined;
  companyName?: string | undefined;
  locationName?: string | undefined;
  status?: string | undefined;
  createdDate!: Date;
  lastUpdatedDate!: Date;
  externalRequestID?: string | undefined;
  externalRequestData?: string | undefined;

  constructor(data?: IBookingSearchResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingKey = _data["bookingKey"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.birthDate = _data["birthDate"]
        ? new Date(_data["birthDate"].toString())
        : <any>undefined;
      this.sex = _data["sex"];
      this.mobile = _data["mobile"];
      this.scanType = _data["scanType"];
      this.companyName = _data["companyName"];
      this.locationName = _data["locationName"];
      this.status = _data["status"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
      this.lastUpdatedDate = _data["lastUpdatedDate"]
        ? new Date(_data["lastUpdatedDate"].toString())
        : <any>undefined;
      this.externalRequestID = _data["externalRequestID"];
      this.externalRequestData = _data["externalRequestData"];
    }
  }

  static fromJS(data: any): BookingSearchResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new BookingSearchResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingKey"] = this.bookingKey;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["birthDate"] = this.birthDate
      ? this.birthDate.toISOString()
      : <any>undefined;
    data["sex"] = this.sex;
    data["mobile"] = this.mobile;
    data["scanType"] = this.scanType;
    data["companyName"] = this.companyName;
    data["locationName"] = this.locationName;
    data["status"] = this.status;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    data["lastUpdatedDate"] = this.lastUpdatedDate
      ? this.lastUpdatedDate.toISOString()
      : <any>undefined;
    data["externalRequestID"] = this.externalRequestID;
    data["externalRequestData"] = this.externalRequestData;
    return data;
  }
}

export interface IBookingSearchResponseSupport {
  bookingKey: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  birthDate?: Date | undefined;
  sex?: string | undefined;
  mobile?: string | undefined;
  scanType?: string | undefined;
  companyName?: string | undefined;
  locationName?: string | undefined;
  status?: string | undefined;
  createdDate: Date;
  lastUpdatedDate: Date;
  externalRequestID?: string | undefined;
  externalRequestData?: string | undefined;
}

export class BookingNoSMSResponseSupport
  implements IBookingNoSMSResponseSupport
{
  bookingKey!: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  mobile?: string | undefined;
  companyKey!: number;
  companyName?: string | undefined;
  locationKey!: number;
  locationName?: string | undefined;
  referringDoctor?: string | undefined;
  status?: string | undefined;
  createdDate!: Date;

  constructor(data?: IBookingNoSMSResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingKey = _data["bookingKey"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.mobile = _data["mobile"];
      this.companyKey = _data["companyKey"];
      this.companyName = _data["companyName"];
      this.locationKey = _data["locationKey"];
      this.locationName = _data["locationName"];
      this.referringDoctor = _data["referringDoctor"];
      this.status = _data["status"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): BookingNoSMSResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new BookingNoSMSResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingKey"] = this.bookingKey;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["mobile"] = this.mobile;
    data["companyKey"] = this.companyKey;
    data["companyName"] = this.companyName;
    data["locationKey"] = this.locationKey;
    data["locationName"] = this.locationName;
    data["referringDoctor"] = this.referringDoctor;
    data["status"] = this.status;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IBookingNoSMSResponseSupport {
  bookingKey: number;
  firstname?: string | undefined;
  lastname?: string | undefined;
  mobile?: string | undefined;
  companyKey: number;
  companyName?: string | undefined;
  locationKey: number;
  locationName?: string | undefined;
  referringDoctor?: string | undefined;
  status?: string | undefined;
  createdDate: Date;
}

export class CompanyRequest implements ICompanyRequest {
  companyName?: string | undefined;
  logo?: string | undefined;

  constructor(data?: ICompanyRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
    }
  }

  static fromJS(data: any): CompanyRequest {
    data = typeof data === "object" ? data : {};
    let result = new CompanyRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    return data;
  }
}

export interface ICompanyRequest {
  companyName?: string | undefined;
  logo?: string | undefined;
}

export class CompanyUpdateRequestSupport
  implements ICompanyUpdateRequestSupport
{
  companyName?: string | undefined;
  logo?: string | undefined;
  active?: boolean | undefined;
  analyticsApiKey?: string | undefined;
  billingName?: string | undefined;
  billingAddress1?: string | undefined;
  billingAddress2?: string | undefined;
  billingCode?: string | undefined;
  accManName?: string | undefined;
  accManEmail?: string | undefined;
  accManPhone?: string | undefined;
  purchaseOrder?: string | undefined;
  chargeRate?: number | undefined;
  billable?: boolean | undefined;

  constructor(data?: ICompanyUpdateRequestSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.logo = _data["logo"];
      this.active = _data["active"];
      this.analyticsApiKey = _data["analyticsApiKey"];
      this.billingName = _data["billingName"];
      this.billingAddress1 = _data["billingAddress1"];
      this.billingAddress2 = _data["billingAddress2"];
      this.billingCode = _data["billingCode"];
      this.accManName = _data["accManName"];
      this.accManEmail = _data["accManEmail"];
      this.accManPhone = _data["accManPhone"];
      this.purchaseOrder = _data["purchaseOrder"];
      this.chargeRate = _data["chargeRate"];
      this.billable = _data["billable"];
    }
  }

  static fromJS(data: any): CompanyUpdateRequestSupport {
    data = typeof data === "object" ? data : {};
    let result = new CompanyUpdateRequestSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["logo"] = this.logo;
    data["active"] = this.active;
    data["analyticsApiKey"] = this.analyticsApiKey;
    data["billingName"] = this.billingName;
    data["billingAddress1"] = this.billingAddress1;
    data["billingAddress2"] = this.billingAddress2;
    data["billingCode"] = this.billingCode;
    data["accManName"] = this.accManName;
    data["accManEmail"] = this.accManEmail;
    data["accManPhone"] = this.accManPhone;
    data["purchaseOrder"] = this.purchaseOrder;
    data["chargeRate"] = this.chargeRate;
    data["billable"] = this.billable;
    return data;
  }
}

export interface ICompanyUpdateRequestSupport {
  companyName?: string | undefined;
  logo?: string | undefined;
  active?: boolean | undefined;
  analyticsApiKey?: string | undefined;
  billingName?: string | undefined;
  billingAddress1?: string | undefined;
  billingAddress2?: string | undefined;
  billingCode?: string | undefined;
  accManName?: string | undefined;
  accManEmail?: string | undefined;
  accManPhone?: string | undefined;
  purchaseOrder?: string | undefined;
  chargeRate?: number | undefined;
  billable?: boolean | undefined;
}

export class BookingSummaryResponse implements IBookingSummaryResponse {
  label?: string | undefined;
  value!: number;

  constructor(data?: IBookingSummaryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.label = _data["label"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): BookingSummaryResponse {
    data = typeof data === "object" ? data : {};
    let result = new BookingSummaryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["label"] = this.label;
    data["value"] = this.value;
    return data;
  }
}

export interface IBookingSummaryResponse {
  label?: string | undefined;
  value: number;
}

export class BookingBreakupResponse implements IBookingBreakupResponse {
  locationKey!: number;
  location?: string | undefined;
  locationShort?: string | undefined;
  source?: string | undefined;
  count!: number;

  constructor(data?: IBookingBreakupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.location = _data["location"];
      this.locationShort = _data["locationShort"];
      this.source = _data["source"];
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): BookingBreakupResponse {
    data = typeof data === "object" ? data : {};
    let result = new BookingBreakupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["location"] = this.location;
    data["locationShort"] = this.locationShort;
    data["source"] = this.source;
    data["count"] = this.count;
    return data;
  }
}

export interface IBookingBreakupResponse {
  locationKey: number;
  location?: string | undefined;
  locationShort?: string | undefined;
  source?: string | undefined;
  count: number;
}

export class SMSSummaryResponse implements ISMSSummaryResponse {
  messages!: number;
  segments!: number;

  constructor(data?: ISMSSummaryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.messages = _data["messages"];
      this.segments = _data["segments"];
    }
  }

  static fromJS(data: any): SMSSummaryResponse {
    data = typeof data === "object" ? data : {};
    let result = new SMSSummaryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["messages"] = this.messages;
    data["segments"] = this.segments;
    return data;
  }
}

export interface ISMSSummaryResponse {
  messages: number;
  segments: number;
}

export class LocationResponseSupport implements ILocationResponseSupport {
  locationKey!: number;
  companyKey!: number;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  companyName?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;
  active!: boolean;

  constructor(data?: ILocationResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.companyKey = _data["companyKey"];
      this.locationName = _data["locationName"];
      this.locationNameShort = _data["locationNameShort"];
      this.companyName = _data["companyName"];
      this.address = _data["address"];
      this.phone = _data["phone"];
      this.active = _data["active"];
    }
  }

  static fromJS(data: any): LocationResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new LocationResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["companyKey"] = this.companyKey;
    data["locationName"] = this.locationName;
    data["locationNameShort"] = this.locationNameShort;
    data["companyName"] = this.companyName;
    data["address"] = this.address;
    data["phone"] = this.phone;
    data["active"] = this.active;
    return data;
  }
}

export interface ILocationResponseSupport {
  locationKey: number;
  companyKey: number;
  locationName?: string | undefined;
  locationNameShort?: string | undefined;
  companyName?: string | undefined;
  address?: string | undefined;
  phone?: string | undefined;
  active: boolean;
}

export class LogResponseSupport implements ILogResponseSupport {
  logKey!: number;
  bookingKey!: number;
  logType?: string | undefined;
  userKey?: number | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  email?: string | undefined;
  comments?: string | undefined;
  createdDate!: Date;

  constructor(data?: ILogResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logKey = _data["logKey"];
      this.bookingKey = _data["bookingKey"];
      this.logType = _data["logType"];
      this.userKey = _data["userKey"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.email = _data["email"];
      this.comments = _data["comments"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): LogResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new LogResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logKey"] = this.logKey;
    data["bookingKey"] = this.bookingKey;
    data["logType"] = this.logType;
    data["userKey"] = this.userKey;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["email"] = this.email;
    data["comments"] = this.comments;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ILogResponseSupport {
  logKey: number;
  bookingKey: number;
  logType?: string | undefined;
  userKey?: number | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  email?: string | undefined;
  comments?: string | undefined;
  createdDate: Date;
}

export class ReferringPracticeLookupRequest
  implements IReferringPracticeLookupRequest
{
  referringPracticeCode?: string | undefined;
  referringPracticeName?: string | undefined;

  constructor(data?: IReferringPracticeLookupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referringPracticeCode = _data["referringPracticeCode"];
      this.referringPracticeName = _data["referringPracticeName"];
    }
  }

  static fromJS(data: any): ReferringPracticeLookupRequest {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPracticeLookupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["referringPracticeCode"] = this.referringPracticeCode;
    data["referringPracticeName"] = this.referringPracticeName;
    return data;
  }
}

export interface IReferringPracticeLookupRequest {
  referringPracticeCode?: string | undefined;
  referringPracticeName?: string | undefined;
}

export class UserResponseSupport implements IUserResponseSupport {
  userKey!: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  accountType?: string | undefined;
  changePassword!: boolean;
  active!: boolean;
  title?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  street?: string | undefined;
  suburb?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  providerNo?: string | undefined;
  practiceName?: string | undefined;
  companyName?: string | undefined;
  createdDate!: Date;
  lastUpdatedDate!: Date;

  constructor(data?: IUserResponseSupport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userKey = _data["userKey"];
      this.email = _data["email"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.accountType = _data["accountType"];
      this.changePassword = _data["changePassword"];
      this.active = _data["active"];
      this.title = _data["title"];
      this.phone = _data["phone"];
      this.fax = _data["fax"];
      this.street = _data["street"];
      this.suburb = _data["suburb"];
      this.state = _data["state"];
      this.postcode = _data["postcode"];
      this.providerNo = _data["providerNo"];
      this.practiceName = _data["practiceName"];
      this.companyName = _data["companyName"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
      this.lastUpdatedDate = _data["lastUpdatedDate"]
        ? new Date(_data["lastUpdatedDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserResponseSupport {
    data = typeof data === "object" ? data : {};
    let result = new UserResponseSupport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userKey"] = this.userKey;
    data["email"] = this.email;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["accountType"] = this.accountType;
    data["changePassword"] = this.changePassword;
    data["active"] = this.active;
    data["title"] = this.title;
    data["phone"] = this.phone;
    data["fax"] = this.fax;
    data["street"] = this.street;
    data["suburb"] = this.suburb;
    data["state"] = this.state;
    data["postcode"] = this.postcode;
    data["providerNo"] = this.providerNo;
    data["practiceName"] = this.practiceName;
    data["companyName"] = this.companyName;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    data["lastUpdatedDate"] = this.lastUpdatedDate
      ? this.lastUpdatedDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IUserResponseSupport {
  userKey: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  accountType?: string | undefined;
  changePassword: boolean;
  active: boolean;
  title?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  street?: string | undefined;
  suburb?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  providerNo?: string | undefined;
  practiceName?: string | undefined;
  companyName?: string | undefined;
  createdDate: Date;
  lastUpdatedDate: Date;
}

export class UserRequest implements IUserRequest {
  firstname?: string | undefined;
  lastname?: string | undefined;
  email?: string | undefined;
  companyKey!: number;
  userType?: string | undefined;
  password?: string | undefined;
  title?: string | undefined;
  practiceName?: string | undefined;
  
  constructor(data?: IUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.email = _data["email"];
      this.companyKey = _data["companyKey"];
      this.userType = _data["userType"];
      this.password = _data["password"];
      this.title = _data["title"];
     
      this.practiceName = _data["practiceName"];
    }
  }

  static fromJS(data: any): UserRequest {
    data = typeof data === "object" ? data : {};
    let result = new UserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["email"] = this.email;
    data["companyKey"] = this.companyKey;
    data["userType"] = this.userType;
    data["password"] = this.password;
    data["title"] = this.title;
    data["practiceName"] = this.practiceName;
    
    return data;
  }
}

export interface IUserRequest {
  userId?: number | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  email?: string | undefined;
  companyKey: number;
  userType?: string | undefined;
  password?: string | undefined;
  title?: string | undefined;
  practiceName?: string | undefined;
  
}

export class UserUpdateRequest implements IUserUpdateRequest {
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  userType?: string | undefined;
  password?: string | undefined;
  changePassword?: boolean | undefined;
  active?: boolean | undefined;
  title?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  street?: string | undefined;
  suburb?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  providerNo?: string | undefined;
  practiceName?: string | undefined;

  constructor(data?: IUserUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.userType = _data["userType"];
      this.password = _data["password"];
      this.changePassword = _data["changePassword"];
      this.active = _data["active"];
      this.title = _data["title"];
      this.phone = _data["phone"];
      this.fax = _data["fax"];
      this.street = _data["street"];
      this.suburb = _data["suburb"];
      this.state = _data["state"];
      this.postcode = _data["postcode"];
      this.providerNo = _data["providerNo"];
      this.practiceName = _data["practiceName"];
    }
  }

  static fromJS(data: any): UserUpdateRequest {
    data = typeof data === "object" ? data : {};
    let result = new UserUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["userType"] = this.userType;
    data["password"] = this.password;
    data["changePassword"] = this.changePassword;
    data["active"] = this.active;
    data["title"] = this.title;
    data["phone"] = this.phone;
    data["fax"] = this.fax;
    data["street"] = this.street;
    data["suburb"] = this.suburb;
    data["state"] = this.state;
    data["postcode"] = this.postcode;
    data["providerNo"] = this.providerNo;
    data["practiceName"] = this.practiceName;
    return data;
  }
}

export interface IUserUpdateRequest {
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  userType?: string | undefined;
  password?: string | undefined;
  changePassword?: boolean | undefined;
  active?: boolean | undefined;
  title?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  street?: string | undefined;
  suburb?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  providerNo?: string | undefined;
  practiceName?: string | undefined;
}

export class UserLoginResponse implements IUserLoginResponse {
  userLoginKey!: number;
  userKey!: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  deviceType?: string | undefined;
  lastAccessedDate!: Date;
  expireDate!: Date;

  constructor(data?: IUserLoginResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userLoginKey = _data["userLoginKey"];
      this.userKey = _data["userKey"];
      this.email = _data["email"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.deviceType = _data["deviceType"];
      this.lastAccessedDate = _data["lastAccessedDate"]
        ? new Date(_data["lastAccessedDate"].toString())
        : <any>undefined;
      this.expireDate = _data["expireDate"]
        ? new Date(_data["expireDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserLoginResponse {
    data = typeof data === "object" ? data : {};
    let result = new UserLoginResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userLoginKey"] = this.userLoginKey;
    data["userKey"] = this.userKey;
    data["email"] = this.email;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["deviceType"] = this.deviceType;
    data["lastAccessedDate"] = this.lastAccessedDate
      ? this.lastAccessedDate.toISOString()
      : <any>undefined;
    data["expireDate"] = this.expireDate
      ? this.expireDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IUserLoginResponse {
  userLoginKey: number;
  userKey: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  deviceType?: string | undefined;
  lastAccessedDate: Date;
  expireDate: Date;
}

export class SingleUseKeyResponse implements ISingleUseKeyResponse {
  referenceKey!: number;
  createdDate!: Date;

  constructor(data?: ISingleUseKeyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referenceKey = _data["referenceKey"];
      this.createdDate = _data["createdDate"]
        ? new Date(_data["createdDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): SingleUseKeyResponse {
    data = typeof data === "object" ? data : {};
    let result = new SingleUseKeyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["referenceKey"] = this.referenceKey;
    data["createdDate"] = this.createdDate
      ? this.createdDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ISingleUseKeyResponse {
  referenceKey: number;
  createdDate: Date;
}

export class AliasResponse implements IAliasResponse {
  aliasKey!: number;
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;

  constructor(data?: IAliasResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aliasKey = _data["aliasKey"];
      this.aliasID = _data["aliasID"];
      this.aliasDescription = _data["aliasDescription"];
    }
  }

  static fromJS(data: any): AliasResponse {
    data = typeof data === "object" ? data : {};
    let result = new AliasResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["aliasKey"] = this.aliasKey;
    data["aliasID"] = this.aliasID;
    data["aliasDescription"] = this.aliasDescription;
    return data;
  }
}

export interface IAliasResponse {
  aliasKey: number;
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;
}

export class AliasRequest implements IAliasRequest {
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;

  constructor(data?: IAliasRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aliasID = _data["aliasID"];
      this.aliasDescription = _data["aliasDescription"];
    }
  }

  static fromJS(data: any): AliasRequest {
    data = typeof data === "object" ? data : {};
    let result = new AliasRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["aliasID"] = this.aliasID;
    data["aliasDescription"] = this.aliasDescription;
    return data;
  }
}

export interface IAliasRequest {
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;
}

export class AliasDetailResponse implements IAliasDetailResponse {
  aliasKey!: number;
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;
  locationAliases?: LocAlias[] | undefined;

  constructor(data?: IAliasDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aliasKey = _data["aliasKey"];
      this.aliasID = _data["aliasID"];
      this.aliasDescription = _data["aliasDescription"];
      if (Array.isArray(_data["locationAliases"])) {
        this.locationAliases = [] as any;
        for (let item of _data["locationAliases"])
          this.locationAliases!.push(LocAlias.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AliasDetailResponse {
    data = typeof data === "object" ? data : {};
    let result = new AliasDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["aliasKey"] = this.aliasKey;
    data["aliasID"] = this.aliasID;
    data["aliasDescription"] = this.aliasDescription;
    if (Array.isArray(this.locationAliases)) {
      data["locationAliases"] = [];
      for (let item of this.locationAliases)
        data["locationAliases"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAliasDetailResponse {
  aliasKey: number;
  aliasID?: string | undefined;
  aliasDescription?: string | undefined;
  locationAliases?: LocAlias[] | undefined;
}

export class LocAlias implements ILocAlias {
  locationAliasKey!: number;
  locationKey!: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  activeLocation!: boolean;
  aliasLocationName?: string | undefined;
  smartRouting!: boolean;

  constructor(data?: ILocAlias) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationAliasKey = _data["locationAliasKey"];
      this.locationKey = _data["locationKey"];
      this.companyName = _data["companyName"];
      this.locationName = _data["locationName"];
      this.activeLocation = _data["activeLocation"];
      this.aliasLocationName = _data["aliasLocationName"];
      this.smartRouting = _data["smartRouting"];
    }
  }

  static fromJS(data: any): LocAlias {
    data = typeof data === "object" ? data : {};
    let result = new LocAlias();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationAliasKey"] = this.locationAliasKey;
    data["locationKey"] = this.locationKey;
    data["companyName"] = this.companyName;
    data["locationName"] = this.locationName;
    data["activeLocation"] = this.activeLocation;
    data["aliasLocationName"] = this.aliasLocationName;
    data["smartRouting"] = this.smartRouting;
    return data;
  }
}

export interface ILocAlias {
  locationAliasKey: number;
  locationKey: number;
  companyName?: string | undefined;
  locationName?: string | undefined;
  activeLocation: boolean;
  aliasLocationName?: string | undefined;
  smartRouting: boolean;
}

export class LocationAliasRequest implements ILocationAliasRequest {
  locationKey!: number;
  aliasLocationName?: string | undefined;
  smartRouting!: boolean;

  constructor(data?: ILocationAliasRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationKey = _data["locationKey"];
      this.aliasLocationName = _data["aliasLocationName"];
      this.smartRouting = _data["smartRouting"];
    }
  }

  static fromJS(data: any): LocationAliasRequest {
    data = typeof data === "object" ? data : {};
    let result = new LocationAliasRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["locationKey"] = this.locationKey;
    data["aliasLocationName"] = this.aliasLocationName;
    data["smartRouting"] = this.smartRouting;
    return data;
  }
}

export interface ILocationAliasRequest {
  locationKey: number;
  aliasLocationName?: string | undefined;
  smartRouting: boolean;
}

export class LocationAliasUpdateRequest implements ILocationAliasUpdateRequest {
  aliasLocationName?: string | undefined;
  smartRouting!: boolean;

  constructor(data?: ILocationAliasUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aliasLocationName = _data["aliasLocationName"];
      this.smartRouting = _data["smartRouting"];
    }
  }

  static fromJS(data: any): LocationAliasUpdateRequest {
    data = typeof data === "object" ? data : {};
    let result = new LocationAliasUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["aliasLocationName"] = this.aliasLocationName;
    data["smartRouting"] = this.smartRouting;
    return data;
  }
}

export interface ILocationAliasUpdateRequest {
  aliasLocationName?: string | undefined;
  smartRouting: boolean;
}

export class EReferralResponse implements IEReferralResponse {
  companyName?: string | undefined;
  referringPractices?: ReferringPractice[] | undefined;

  constructor(data?: IEReferralResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      if (Array.isArray(_data["referringPractices"])) {
        this.referringPractices = [] as any;
        for (let item of _data["referringPractices"])
          this.referringPractices!.push(ReferringPractice.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EReferralResponse {
    data = typeof data === "object" ? data : {};
    let result = new EReferralResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    if (Array.isArray(this.referringPractices)) {
      data["referringPractices"] = [];
      for (let item of this.referringPractices)
        data["referringPractices"].push(item.toJSON());
    }
    return data;
  }
}

export interface IEReferralResponse {
  companyName?: string | undefined;
  referringPractices?: ReferringPractice[] | undefined;
}

export class ReferringPractice implements IReferringPractice {
  practiceName?: string | undefined;
  lastProcessedDate!: Date;

  constructor(data?: IReferringPractice) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.practiceName = _data["practiceName"];
      this.lastProcessedDate = _data["lastProcessedDate"]
        ? new Date(_data["lastProcessedDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ReferringPractice {
    data = typeof data === "object" ? data : {};
    let result = new ReferringPractice();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["practiceName"] = this.practiceName;
    data["lastProcessedDate"] = this.lastProcessedDate
      ? this.lastProcessedDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IReferringPractice {
  practiceName?: string | undefined;
  lastProcessedDate: Date;
}

export class BookingsOverviewResponse implements IBookingsOverviewResponse {
  today!: number;
  yesterday!: number;
  thisMonth!: number;
  lastMonth!: number;
  lastMonthValue!: number;
  weeklyHistory?: WeeklyCount[] | undefined;
  comparedDay!: number;
  comparedWeek!: number;
  activeRefPractices!: number;
  activeRefDoctors!: number;

  constructor(data?: IBookingsOverviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.today = _data["today"];
      this.yesterday = _data["yesterday"];
      this.thisMonth = _data["thisMonth"];
      this.lastMonth = _data["lastMonth"];
      this.lastMonthValue = _data["lastMonthValue"];
      if (Array.isArray(_data["weeklyHistory"])) {
        this.weeklyHistory = [] as any;
        for (let item of _data["weeklyHistory"])
          this.weeklyHistory!.push(WeeklyCount.fromJS(item));
      }
      this.comparedDay = _data["comparedDay"];
      this.comparedWeek = _data["comparedWeek"];
      this.activeRefPractices = _data["activeRefPractices"];
      this.activeRefDoctors = _data["activeRefDoctors"];
    }
  }

  static fromJS(data: any): BookingsOverviewResponse {
    data = typeof data === "object" ? data : {};
    let result = new BookingsOverviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["today"] = this.today;
    data["yesterday"] = this.yesterday;
    data["thisMonth"] = this.thisMonth;
    data["lastMonth"] = this.lastMonth;
    data["lastMonthValue"] = this.lastMonthValue;
    if (Array.isArray(this.weeklyHistory)) {
      data["weeklyHistory"] = [];
      for (let item of this.weeklyHistory)
        data["weeklyHistory"].push(item.toJSON());
    }
    data["comparedDay"] = this.comparedDay;
    data["comparedWeek"] = this.comparedWeek;
    data["activeRefPractices"] = this.activeRefPractices;
    data["activeRefDoctors"] = this.activeRefDoctors;
    return data;
  }
}

export interface IBookingsOverviewResponse {
  today: number;
  yesterday: number;
  thisMonth: number;
  lastMonth: number;
  lastMonthValue: number;
  weeklyHistory?: WeeklyCount[] | undefined;
  comparedDay: number;
  comparedWeek: number;
  activeRefPractices: number;
  activeRefDoctors: number;
}

export class WeeklyCount implements IWeeklyCount {
  weekEndingDate!: Date;
  count!: number;

  constructor(data?: IWeeklyCount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.weekEndingDate = _data["weekEndingDate"]
        ? new Date(_data["weekEndingDate"].toString())
        : <any>undefined;
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): WeeklyCount {
    data = typeof data === "object" ? data : {};
    let result = new WeeklyCount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["weekEndingDate"] = this.weekEndingDate
      ? this.weekEndingDate.toISOString()
      : <any>undefined;
    data["count"] = this.count;
    return data;
  }
}

export interface IWeeklyCount {
  weekEndingDate: Date;
  count: number;
}

export class OpenRequestsOverviewResponse
  implements IOpenRequestsOverviewResponse
{
  companyKey!: number;
  companyName?: string | undefined;
  billingCode?: string | undefined;
  count!: number;

  constructor(data?: IOpenRequestsOverviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyKey = _data["companyKey"];
      this.companyName = _data["companyName"];
      this.billingCode = _data["billingCode"];
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): OpenRequestsOverviewResponse {
    data = typeof data === "object" ? data : {};
    let result = new OpenRequestsOverviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyKey"] = this.companyKey;
    data["companyName"] = this.companyName;
    data["billingCode"] = this.billingCode;
    data["count"] = this.count;
    return data;
  }
}

export interface IOpenRequestsOverviewResponse {
  companyKey: number;
  companyName?: string | undefined;
  billingCode?: string | undefined;
  count: number;
}

export class RevenueOverviewResponse implements IRevenueOverviewResponse {
  monthEndingDate!: Date;
  revenue!: number;

  constructor(data?: IRevenueOverviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.monthEndingDate = _data["monthEndingDate"]
        ? new Date(_data["monthEndingDate"].toString())
        : <any>undefined;
      this.revenue = _data["revenue"];
    }
  }

  static fromJS(data: any): RevenueOverviewResponse {
    data = typeof data === "object" ? data : {};
    let result = new RevenueOverviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["monthEndingDate"] = this.monthEndingDate
      ? this.monthEndingDate.toISOString()
      : <any>undefined;
    data["revenue"] = this.revenue;
    return data;
  }
}

export interface IRevenueOverviewResponse {
  monthEndingDate: Date;
  revenue: number;
}

export class DuplicateOverviewResponse implements IDuplicateOverviewResponse {
  date!: Date;
  count!: number;

  constructor(data?: IDuplicateOverviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): DuplicateOverviewResponse {
    data = typeof data === "object" ? data : {};
    let result = new DuplicateOverviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["count"] = this.count;
    return data;
  }
}

export interface IDuplicateOverviewResponse {
  date: Date;
  count: number;
}

export class BreakupResponse implements IBreakupResponse {
  companyName?: string | undefined;
  billingCode?: string | undefined;
  value!: number;

  constructor(data?: IBreakupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.billingCode = _data["billingCode"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): BreakupResponse {
    data = typeof data === "object" ? data : {};
    let result = new BreakupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["billingCode"] = this.billingCode;
    data["value"] = this.value;
    return data;
  }
}

export interface IBreakupResponse {
  companyName?: string | undefined;
  billingCode?: string | undefined;
  value: number;
}

export class OpenRequestsBreakupResponse
  implements IOpenRequestsBreakupResponse
{
  age!: number;
  count!: number;

  constructor(data?: IOpenRequestsBreakupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.age = _data["age"];
      this.count = _data["count"];
    }
  }

  static fromJS(data: any): OpenRequestsBreakupResponse {
    data = typeof data === "object" ? data : {};
    let result = new OpenRequestsBreakupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["age"] = this.age;
    data["count"] = this.count;
    return data;
  }
}

export interface IOpenRequestsBreakupResponse {
  age: number;
  count: number;
}

export class TokenResponse implements ITokenResponse {
  accessToken?: string | undefined;
  refreshToken?: RefreshTokenDto | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;

  constructor(data?: ITokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.refreshToken = _data["refreshToken"]
        ? RefreshTokenDto.fromJS(_data["refreshToken"])
        : <any>undefined;
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
    }
  }

  static fromJS(data: any): TokenResponse {
    data = typeof data === "object" ? data : {};
    let result = new TokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken;
    data["refreshToken"] = this.refreshToken
      ? this.refreshToken.toJSON()
      : <any>undefined;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    return data;
  }
}

export interface ITokenResponse {
  accessToken?: string | undefined;
  refreshToken?: RefreshTokenDto | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
}

export class RefreshTokenDto implements IRefreshTokenDto {
  token?: string | undefined;
  expires!: Date;

  constructor(data?: IRefreshTokenDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
      this.expires = _data["expires"]
        ? new Date(_data["expires"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): RefreshTokenDto {
    data = typeof data === "object" ? data : {};
    let result = new RefreshTokenDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["token"] = this.token;
    data["expires"] = this.expires
      ? this.expires.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IRefreshTokenDto {
  token?: string | undefined;
  expires: Date;
}

export class UserLoginRequest implements IUserLoginRequest {
  email?: string | undefined;
  password?: string | undefined;
  device?: string | undefined;

  constructor(data?: IUserLoginRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
      this.device = _data["device"];
    }
  }

  static fromJS(data: any): UserLoginRequest {
    data = typeof data === "object" ? data : {};
    let result = new UserLoginRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    data["device"] = this.device;
    return data;
  }
}

export interface IUserLoginRequest {
  email?: string | undefined;
  password?: string | undefined;
  device?: string | undefined;
}

export class RefreshAuthenticationRequest
  implements IRefreshAuthenticationRequest
{
  token?: string | undefined;

  constructor(data?: IRefreshAuthenticationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
    }
  }

  static fromJS(data: any): RefreshAuthenticationRequest {
    data = typeof data === "object" ? data : {};
    let result = new RefreshAuthenticationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["token"] = this.token;
    return data;
  }
}

export interface IRefreshAuthenticationRequest {
  token?: string | undefined;
}

export class UserResponse implements IUserResponse {
  id!: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  accountType?: string | undefined;

  constructor(data?: IUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.email = _data["email"];
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.accountType = _data["accountType"];
    }
  }

  static fromJS(data: any): UserResponse {
    data = typeof data === "object" ? data : {};
    let result = new UserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["email"] = this.email;
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["accountType"] = this.accountType;
    return data;
  }
}

export interface IUserResponse {
  id: number;
  email?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  accountType?: string | undefined;
}

export class UserChangePasswordRequest implements IUserChangePasswordRequest {
  currentPassword?: string | undefined;
  newPassword?: string | undefined;

  constructor(data?: IUserChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): UserChangePasswordRequest {
    data = typeof data === "object" ? data : {};
    let result = new UserChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }
}

export interface IUserChangePasswordRequest {
  currentPassword?: string | undefined;
  newPassword?: string | undefined;
}

export class PasswordResetRequest implements IPasswordResetRequest {
  email?: string | undefined;
  password?: string | undefined;
  sukToken!: string;

  constructor(data?: IPasswordResetRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
      this.sukToken = _data["sukToken"];
    }
  }

  static fromJS(data: any): PasswordResetRequest {
    data = typeof data === "object" ? data : {};
    let result = new PasswordResetRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    data["sukToken"] = this.sukToken;
    return data;
  }
}

export interface IPasswordResetRequest {
  email?: string | undefined;
  password?: string | undefined;
  sukToken: string;
}

export interface ISearchResponse{
  providerName:string | undefined;
  searchStatus:string | undefined;
  matches:number | undefined;
}
export class SearchResponse implements ISearchResponse{
  providerName: string;
  searchStatus: string;
  matches: number;
  constructor(data?: ISearchResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(_data?: any) {
    if (_data) {
      this.providerName = _data["providerName"];
      this.searchStatus = _data["searchStatus"];
      this.matches = _data["matches"];
    }
  }
  static fromJS(data: any): SearchResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchResponse();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["providerName"] = this.providerName;
    data["searchStatus"] = this.searchStatus;
    data["matches"] = this.matches;
    return data;
  }
}
export class ApiException extends Error {
  exMessage: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.exMessage = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
